/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.snapchat = (function() {

    /**
     * Namespace snapchat.
     * @exports snapchat
     * @namespace
     */
    var snapchat = {};

    snapchat.bitmoji = (function() {

        /**
         * Namespace bitmoji.
         * @memberof snapchat
         * @namespace
         */
        var bitmoji = {};

        bitmoji.api = (function() {

            /**
             * Namespace api.
             * @memberof snapchat.bitmoji
             * @namespace
             */
            var api = {};

            api.NewCategoriesPromoItem = (function() {

                /**
                 * Properties of a NewCategoriesPromoItem.
                 * @memberof snapchat.bitmoji.api
                 * @interface INewCategoriesPromoItem
                 * @property {Uint8Array|null} [category] NewCategoriesPromoItem category
                 * @property {number|Long|null} [starts] NewCategoriesPromoItem starts
                 * @property {number|Long|null} [expires] NewCategoriesPromoItem expires
                 */

                /**
                 * Constructs a new NewCategoriesPromoItem.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a NewCategoriesPromoItem.
                 * @implements INewCategoriesPromoItem
                 * @constructor
                 * @param {snapchat.bitmoji.api.INewCategoriesPromoItem=} [properties] Properties to set
                 */
                function NewCategoriesPromoItem(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NewCategoriesPromoItem category.
                 * @member {Uint8Array} category
                 * @memberof snapchat.bitmoji.api.NewCategoriesPromoItem
                 * @instance
                 */
                NewCategoriesPromoItem.prototype.category = $util.newBuffer([]);

                /**
                 * NewCategoriesPromoItem starts.
                 * @member {number|Long} starts
                 * @memberof snapchat.bitmoji.api.NewCategoriesPromoItem
                 * @instance
                 */
                NewCategoriesPromoItem.prototype.starts = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * NewCategoriesPromoItem expires.
                 * @member {number|Long} expires
                 * @memberof snapchat.bitmoji.api.NewCategoriesPromoItem
                 * @instance
                 */
                NewCategoriesPromoItem.prototype.expires = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new NewCategoriesPromoItem instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.NewCategoriesPromoItem
                 * @static
                 * @param {snapchat.bitmoji.api.INewCategoriesPromoItem=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.NewCategoriesPromoItem} NewCategoriesPromoItem instance
                 */
                NewCategoriesPromoItem.create = function create(properties) {
                    return new NewCategoriesPromoItem(properties);
                };

                /**
                 * Decodes a NewCategoriesPromoItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.NewCategoriesPromoItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.NewCategoriesPromoItem} NewCategoriesPromoItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NewCategoriesPromoItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.NewCategoriesPromoItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.category = reader.bytes();
                            break;
                        case 2:
                            message.starts = reader.int64();
                            break;
                        case 3:
                            message.expires = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return NewCategoriesPromoItem;
            })();

            api.NewSectionsPromoItem = (function() {

                /**
                 * Properties of a NewSectionsPromoItem.
                 * @memberof snapchat.bitmoji.api
                 * @interface INewSectionsPromoItem
                 * @property {Uint8Array|null} [category] NewSectionsPromoItem category
                 * @property {number|null} [section_id] NewSectionsPromoItem section_id
                 * @property {number|Long|null} [starts] NewSectionsPromoItem starts
                 * @property {number|Long|null} [expires] NewSectionsPromoItem expires
                 */

                /**
                 * Constructs a new NewSectionsPromoItem.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a NewSectionsPromoItem.
                 * @implements INewSectionsPromoItem
                 * @constructor
                 * @param {snapchat.bitmoji.api.INewSectionsPromoItem=} [properties] Properties to set
                 */
                function NewSectionsPromoItem(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NewSectionsPromoItem category.
                 * @member {Uint8Array} category
                 * @memberof snapchat.bitmoji.api.NewSectionsPromoItem
                 * @instance
                 */
                NewSectionsPromoItem.prototype.category = $util.newBuffer([]);

                /**
                 * NewSectionsPromoItem section_id.
                 * @member {number} section_id
                 * @memberof snapchat.bitmoji.api.NewSectionsPromoItem
                 * @instance
                 */
                NewSectionsPromoItem.prototype.section_id = 0;

                /**
                 * NewSectionsPromoItem starts.
                 * @member {number|Long} starts
                 * @memberof snapchat.bitmoji.api.NewSectionsPromoItem
                 * @instance
                 */
                NewSectionsPromoItem.prototype.starts = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * NewSectionsPromoItem expires.
                 * @member {number|Long} expires
                 * @memberof snapchat.bitmoji.api.NewSectionsPromoItem
                 * @instance
                 */
                NewSectionsPromoItem.prototype.expires = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new NewSectionsPromoItem instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.NewSectionsPromoItem
                 * @static
                 * @param {snapchat.bitmoji.api.INewSectionsPromoItem=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.NewSectionsPromoItem} NewSectionsPromoItem instance
                 */
                NewSectionsPromoItem.create = function create(properties) {
                    return new NewSectionsPromoItem(properties);
                };

                /**
                 * Decodes a NewSectionsPromoItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.NewSectionsPromoItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.NewSectionsPromoItem} NewSectionsPromoItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NewSectionsPromoItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.NewSectionsPromoItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.category = reader.bytes();
                            break;
                        case 2:
                            message.section_id = reader.int32();
                            break;
                        case 3:
                            message.starts = reader.int64();
                            break;
                        case 4:
                            message.expires = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return NewSectionsPromoItem;
            })();

            api.NewOptionsPromoItem = (function() {

                /**
                 * Properties of a NewOptionsPromoItem.
                 * @memberof snapchat.bitmoji.api
                 * @interface INewOptionsPromoItem
                 * @property {Uint8Array|null} [category] NewOptionsPromoItem category
                 * @property {Array.<number>|null} [option_ids] NewOptionsPromoItem option_ids
                 */

                /**
                 * Constructs a new NewOptionsPromoItem.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a NewOptionsPromoItem.
                 * @implements INewOptionsPromoItem
                 * @constructor
                 * @param {snapchat.bitmoji.api.INewOptionsPromoItem=} [properties] Properties to set
                 */
                function NewOptionsPromoItem(properties) {
                    this.option_ids = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NewOptionsPromoItem category.
                 * @member {Uint8Array} category
                 * @memberof snapchat.bitmoji.api.NewOptionsPromoItem
                 * @instance
                 */
                NewOptionsPromoItem.prototype.category = $util.newBuffer([]);

                /**
                 * NewOptionsPromoItem option_ids.
                 * @member {Array.<number>} option_ids
                 * @memberof snapchat.bitmoji.api.NewOptionsPromoItem
                 * @instance
                 */
                NewOptionsPromoItem.prototype.option_ids = $util.emptyArray;

                /**
                 * Creates a new NewOptionsPromoItem instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.NewOptionsPromoItem
                 * @static
                 * @param {snapchat.bitmoji.api.INewOptionsPromoItem=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.NewOptionsPromoItem} NewOptionsPromoItem instance
                 */
                NewOptionsPromoItem.create = function create(properties) {
                    return new NewOptionsPromoItem(properties);
                };

                /**
                 * Decodes a NewOptionsPromoItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.NewOptionsPromoItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.NewOptionsPromoItem} NewOptionsPromoItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NewOptionsPromoItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.NewOptionsPromoItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.category = reader.bytes();
                            break;
                        case 2:
                            if (!(message.option_ids && message.option_ids.length))
                                message.option_ids = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.option_ids.push(reader.int32());
                            } else
                                message.option_ids.push(reader.int32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return NewOptionsPromoItem;
            })();

            api.AvatarBuilderPromoData = (function() {

                /**
                 * Properties of an AvatarBuilderPromoData.
                 * @memberof snapchat.bitmoji.api
                 * @interface IAvatarBuilderPromoData
                 * @property {Array.<snapchat.bitmoji.api.INewCategoriesPromoItem>|null} [new_categories] AvatarBuilderPromoData new_categories
                 * @property {Array.<snapchat.bitmoji.api.INewSectionsPromoItem>|null} [new_sections] AvatarBuilderPromoData new_sections
                 * @property {Array.<snapchat.bitmoji.api.INewOptionsPromoItem>|null} [new_option_ids] AvatarBuilderPromoData new_option_ids
                 */

                /**
                 * Constructs a new AvatarBuilderPromoData.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents an AvatarBuilderPromoData.
                 * @implements IAvatarBuilderPromoData
                 * @constructor
                 * @param {snapchat.bitmoji.api.IAvatarBuilderPromoData=} [properties] Properties to set
                 */
                function AvatarBuilderPromoData(properties) {
                    this.new_categories = [];
                    this.new_sections = [];
                    this.new_option_ids = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AvatarBuilderPromoData new_categories.
                 * @member {Array.<snapchat.bitmoji.api.INewCategoriesPromoItem>} new_categories
                 * @memberof snapchat.bitmoji.api.AvatarBuilderPromoData
                 * @instance
                 */
                AvatarBuilderPromoData.prototype.new_categories = $util.emptyArray;

                /**
                 * AvatarBuilderPromoData new_sections.
                 * @member {Array.<snapchat.bitmoji.api.INewSectionsPromoItem>} new_sections
                 * @memberof snapchat.bitmoji.api.AvatarBuilderPromoData
                 * @instance
                 */
                AvatarBuilderPromoData.prototype.new_sections = $util.emptyArray;

                /**
                 * AvatarBuilderPromoData new_option_ids.
                 * @member {Array.<snapchat.bitmoji.api.INewOptionsPromoItem>} new_option_ids
                 * @memberof snapchat.bitmoji.api.AvatarBuilderPromoData
                 * @instance
                 */
                AvatarBuilderPromoData.prototype.new_option_ids = $util.emptyArray;

                /**
                 * Creates a new AvatarBuilderPromoData instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.AvatarBuilderPromoData
                 * @static
                 * @param {snapchat.bitmoji.api.IAvatarBuilderPromoData=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.AvatarBuilderPromoData} AvatarBuilderPromoData instance
                 */
                AvatarBuilderPromoData.create = function create(properties) {
                    return new AvatarBuilderPromoData(properties);
                };

                /**
                 * Decodes an AvatarBuilderPromoData message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.AvatarBuilderPromoData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.AvatarBuilderPromoData} AvatarBuilderPromoData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AvatarBuilderPromoData.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.AvatarBuilderPromoData();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.new_categories && message.new_categories.length))
                                message.new_categories = [];
                            message.new_categories.push($root.snapchat.bitmoji.api.NewCategoriesPromoItem.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.new_sections && message.new_sections.length))
                                message.new_sections = [];
                            message.new_sections.push($root.snapchat.bitmoji.api.NewSectionsPromoItem.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.new_option_ids && message.new_option_ids.length))
                                message.new_option_ids = [];
                            message.new_option_ids.push($root.snapchat.bitmoji.api.NewOptionsPromoItem.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return AvatarBuilderPromoData;
            })();

            api.HairStyle = (function() {

                /**
                 * Properties of a HairStyle.
                 * @memberof snapchat.bitmoji.api
                 * @interface IHairStyle
                 * @property {number|null} [ombre] HairStyle ombre
                 * @property {number|null} [highlights] HairStyle highlights
                 */

                /**
                 * Constructs a new HairStyle.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a HairStyle.
                 * @implements IHairStyle
                 * @constructor
                 * @param {snapchat.bitmoji.api.IHairStyle=} [properties] Properties to set
                 */
                function HairStyle(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HairStyle ombre.
                 * @member {number} ombre
                 * @memberof snapchat.bitmoji.api.HairStyle
                 * @instance
                 */
                HairStyle.prototype.ombre = 0;

                /**
                 * HairStyle highlights.
                 * @member {number} highlights
                 * @memberof snapchat.bitmoji.api.HairStyle
                 * @instance
                 */
                HairStyle.prototype.highlights = 0;

                /**
                 * Creates a new HairStyle instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.HairStyle
                 * @static
                 * @param {snapchat.bitmoji.api.IHairStyle=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.HairStyle} HairStyle instance
                 */
                HairStyle.create = function create(properties) {
                    return new HairStyle(properties);
                };

                /**
                 * Decodes a HairStyle message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.HairStyle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.HairStyle} HairStyle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HairStyle.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.HairStyle();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ombre = reader.sint32();
                            break;
                        case 2:
                            message.highlights = reader.sint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return HairStyle;
            })();

            api.HairUntreatedToTreated = (function() {

                /**
                 * Properties of a HairUntreatedToTreated.
                 * @memberof snapchat.bitmoji.api
                 * @interface IHairUntreatedToTreated
                 * @property {Object.<string,snapchat.bitmoji.api.IHairStyle>|null} [hair_style_mappings] HairUntreatedToTreated hair_style_mappings
                 */

                /**
                 * Constructs a new HairUntreatedToTreated.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a HairUntreatedToTreated.
                 * @implements IHairUntreatedToTreated
                 * @constructor
                 * @param {snapchat.bitmoji.api.IHairUntreatedToTreated=} [properties] Properties to set
                 */
                function HairUntreatedToTreated(properties) {
                    this.hair_style_mappings = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HairUntreatedToTreated hair_style_mappings.
                 * @member {Object.<string,snapchat.bitmoji.api.IHairStyle>} hair_style_mappings
                 * @memberof snapchat.bitmoji.api.HairUntreatedToTreated
                 * @instance
                 */
                HairUntreatedToTreated.prototype.hair_style_mappings = $util.emptyObject;

                /**
                 * Creates a new HairUntreatedToTreated instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.HairUntreatedToTreated
                 * @static
                 * @param {snapchat.bitmoji.api.IHairUntreatedToTreated=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.HairUntreatedToTreated} HairUntreatedToTreated instance
                 */
                HairUntreatedToTreated.create = function create(properties) {
                    return new HairUntreatedToTreated(properties);
                };

                /**
                 * Decodes a HairUntreatedToTreated message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.HairUntreatedToTreated
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.HairUntreatedToTreated} HairUntreatedToTreated
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HairUntreatedToTreated.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.HairUntreatedToTreated(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (message.hair_style_mappings === $util.emptyObject)
                                message.hair_style_mappings = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.snapchat.bitmoji.api.HairStyle.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.hair_style_mappings[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return HairUntreatedToTreated;
            })();

            api.TraitMetadata = (function() {

                /**
                 * Properties of a TraitMetadata.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITraitMetadata
                 * @property {snapchat.bitmoji.api.IHairUntreatedToTreated|null} [hair_untreated_to_treated] TraitMetadata hair_untreated_to_treated
                 * @property {Array.<number>|null} [lipless_mouths] TraitMetadata lipless_mouths
                 * @property {Array.<number>|null} [colourless_beards] TraitMetadata colourless_beards
                 * @property {Array.<number>|null} [colourless_hair] TraitMetadata colourless_hair
                 * @property {Object.<string,snapchat.bitmoji.api.IColourList>|null} [swatch_sets] TraitMetadata swatch_sets
                 */

                /**
                 * Constructs a new TraitMetadata.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a TraitMetadata.
                 * @implements ITraitMetadata
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITraitMetadata=} [properties] Properties to set
                 */
                function TraitMetadata(properties) {
                    this.lipless_mouths = [];
                    this.colourless_beards = [];
                    this.colourless_hair = [];
                    this.swatch_sets = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TraitMetadata hair_untreated_to_treated.
                 * @member {snapchat.bitmoji.api.IHairUntreatedToTreated|null|undefined} hair_untreated_to_treated
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @instance
                 */
                TraitMetadata.prototype.hair_untreated_to_treated = null;

                /**
                 * TraitMetadata lipless_mouths.
                 * @member {Array.<number>} lipless_mouths
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @instance
                 */
                TraitMetadata.prototype.lipless_mouths = $util.emptyArray;

                /**
                 * TraitMetadata colourless_beards.
                 * @member {Array.<number>} colourless_beards
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @instance
                 */
                TraitMetadata.prototype.colourless_beards = $util.emptyArray;

                /**
                 * TraitMetadata colourless_hair.
                 * @member {Array.<number>} colourless_hair
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @instance
                 */
                TraitMetadata.prototype.colourless_hair = $util.emptyArray;

                /**
                 * TraitMetadata swatch_sets.
                 * @member {Object.<string,snapchat.bitmoji.api.IColourList>} swatch_sets
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @instance
                 */
                TraitMetadata.prototype.swatch_sets = $util.emptyObject;

                /**
                 * Creates a new TraitMetadata instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @static
                 * @param {snapchat.bitmoji.api.ITraitMetadata=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.TraitMetadata} TraitMetadata instance
                 */
                TraitMetadata.create = function create(properties) {
                    return new TraitMetadata(properties);
                };

                /**
                 * Decodes a TraitMetadata message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.TraitMetadata
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.TraitMetadata} TraitMetadata
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TraitMetadata.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.TraitMetadata(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.hair_untreated_to_treated = $root.snapchat.bitmoji.api.HairUntreatedToTreated.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.lipless_mouths && message.lipless_mouths.length))
                                message.lipless_mouths = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.lipless_mouths.push(reader.int32());
                            } else
                                message.lipless_mouths.push(reader.int32());
                            break;
                        case 3:
                            if (!(message.colourless_beards && message.colourless_beards.length))
                                message.colourless_beards = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.colourless_beards.push(reader.int32());
                            } else
                                message.colourless_beards.push(reader.int32());
                            break;
                        case 4:
                            if (!(message.colourless_hair && message.colourless_hair.length))
                                message.colourless_hair = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.colourless_hair.push(reader.int32());
                            } else
                                message.colourless_hair.push(reader.int32());
                            break;
                        case 5:
                            if (message.swatch_sets === $util.emptyObject)
                                message.swatch_sets = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.snapchat.bitmoji.api.ColourList.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.swatch_sets[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return TraitMetadata;
            })();

            api.TraitCategoryOption = (function() {

                /**
                 * Properties of a TraitCategoryOption.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITraitCategoryOption
                 * @property {number|null} [value] TraitCategoryOption value
                 * @property {Array.<number>|null} [color_palette_swatch_set_ids] TraitCategoryOption color_palette_swatch_set_ids
                 * @property {Array.<number>|null} [secondary_colors] TraitCategoryOption secondary_colors
                 * @property {number|null} [default_swatch_set_index] TraitCategoryOption default_swatch_set_index
                 */

                /**
                 * Constructs a new TraitCategoryOption.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a TraitCategoryOption.
                 * @implements ITraitCategoryOption
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITraitCategoryOption=} [properties] Properties to set
                 */
                function TraitCategoryOption(properties) {
                    this.color_palette_swatch_set_ids = [];
                    this.secondary_colors = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TraitCategoryOption value.
                 * @member {number} value
                 * @memberof snapchat.bitmoji.api.TraitCategoryOption
                 * @instance
                 */
                TraitCategoryOption.prototype.value = 0;

                /**
                 * TraitCategoryOption color_palette_swatch_set_ids.
                 * @member {Array.<number>} color_palette_swatch_set_ids
                 * @memberof snapchat.bitmoji.api.TraitCategoryOption
                 * @instance
                 */
                TraitCategoryOption.prototype.color_palette_swatch_set_ids = $util.emptyArray;

                /**
                 * TraitCategoryOption secondary_colors.
                 * @member {Array.<number>} secondary_colors
                 * @memberof snapchat.bitmoji.api.TraitCategoryOption
                 * @instance
                 */
                TraitCategoryOption.prototype.secondary_colors = $util.emptyArray;

                /**
                 * TraitCategoryOption default_swatch_set_index.
                 * @member {number} default_swatch_set_index
                 * @memberof snapchat.bitmoji.api.TraitCategoryOption
                 * @instance
                 */
                TraitCategoryOption.prototype.default_swatch_set_index = 0;

                /**
                 * Creates a new TraitCategoryOption instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.TraitCategoryOption
                 * @static
                 * @param {snapchat.bitmoji.api.ITraitCategoryOption=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.TraitCategoryOption} TraitCategoryOption instance
                 */
                TraitCategoryOption.create = function create(properties) {
                    return new TraitCategoryOption(properties);
                };

                /**
                 * Decodes a TraitCategoryOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.TraitCategoryOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.TraitCategoryOption} TraitCategoryOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TraitCategoryOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.TraitCategoryOption();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.int32();
                            break;
                        case 2:
                            if (!(message.color_palette_swatch_set_ids && message.color_palette_swatch_set_ids.length))
                                message.color_palette_swatch_set_ids = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.color_palette_swatch_set_ids.push(reader.int32());
                            } else
                                message.color_palette_swatch_set_ids.push(reader.int32());
                            break;
                        case 3:
                            if (!(message.secondary_colors && message.secondary_colors.length))
                                message.secondary_colors = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.secondary_colors.push(reader.int32());
                            } else
                                message.secondary_colors.push(reader.int32());
                            break;
                        case 4:
                            message.default_swatch_set_index = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return TraitCategoryOption;
            })();

            api.TraitCategory = (function() {

                /**
                 * Properties of a TraitCategory.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITraitCategory
                 * @property {string|null} [key] TraitCategory key
                 * @property {Array.<snapchat.bitmoji.api.ITraitCategoryOption>|null} [trait_category_options] TraitCategory trait_category_options
                 */

                /**
                 * Constructs a new TraitCategory.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a TraitCategory.
                 * @implements ITraitCategory
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITraitCategory=} [properties] Properties to set
                 */
                function TraitCategory(properties) {
                    this.trait_category_options = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TraitCategory key.
                 * @member {string} key
                 * @memberof snapchat.bitmoji.api.TraitCategory
                 * @instance
                 */
                TraitCategory.prototype.key = "";

                /**
                 * TraitCategory trait_category_options.
                 * @member {Array.<snapchat.bitmoji.api.ITraitCategoryOption>} trait_category_options
                 * @memberof snapchat.bitmoji.api.TraitCategory
                 * @instance
                 */
                TraitCategory.prototype.trait_category_options = $util.emptyArray;

                /**
                 * Creates a new TraitCategory instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.TraitCategory
                 * @static
                 * @param {snapchat.bitmoji.api.ITraitCategory=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.TraitCategory} TraitCategory instance
                 */
                TraitCategory.create = function create(properties) {
                    return new TraitCategory(properties);
                };

                /**
                 * Decodes a TraitCategory message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.TraitCategory
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.TraitCategory} TraitCategory
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TraitCategory.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.TraitCategory();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.key = reader.string();
                            break;
                        case 2:
                            if (!(message.trait_category_options && message.trait_category_options.length))
                                message.trait_category_options = [];
                            message.trait_category_options.push($root.snapchat.bitmoji.api.TraitCategoryOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return TraitCategory;
            })();

            api.TraitCategories = (function() {

                /**
                 * Properties of a TraitCategories.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITraitCategories
                 * @property {Array.<snapchat.bitmoji.api.ITraitCategory>|null} [trait_category] TraitCategories trait_category
                 */

                /**
                 * Constructs a new TraitCategories.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a TraitCategories.
                 * @implements ITraitCategories
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITraitCategories=} [properties] Properties to set
                 */
                function TraitCategories(properties) {
                    this.trait_category = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TraitCategories trait_category.
                 * @member {Array.<snapchat.bitmoji.api.ITraitCategory>} trait_category
                 * @memberof snapchat.bitmoji.api.TraitCategories
                 * @instance
                 */
                TraitCategories.prototype.trait_category = $util.emptyArray;

                /**
                 * Creates a new TraitCategories instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.TraitCategories
                 * @static
                 * @param {snapchat.bitmoji.api.ITraitCategories=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.TraitCategories} TraitCategories instance
                 */
                TraitCategories.create = function create(properties) {
                    return new TraitCategories(properties);
                };

                /**
                 * Decodes a TraitCategories message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.TraitCategories
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.TraitCategories} TraitCategories
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TraitCategories.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.TraitCategories();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.trait_category && message.trait_category.length))
                                message.trait_category = [];
                            message.trait_category.push($root.snapchat.bitmoji.api.TraitCategory.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return TraitCategories;
            })();

            api.StyleTrait = (function() {

                /**
                 * Properties of a StyleTrait.
                 * @memberof snapchat.bitmoji.api
                 * @interface IStyleTrait
                 * @property {snapchat.bitmoji.api.ITraitCategories|null} [categories] StyleTrait categories
                 */

                /**
                 * Constructs a new StyleTrait.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a StyleTrait.
                 * @implements IStyleTrait
                 * @constructor
                 * @param {snapchat.bitmoji.api.IStyleTrait=} [properties] Properties to set
                 */
                function StyleTrait(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StyleTrait categories.
                 * @member {snapchat.bitmoji.api.ITraitCategories|null|undefined} categories
                 * @memberof snapchat.bitmoji.api.StyleTrait
                 * @instance
                 */
                StyleTrait.prototype.categories = null;

                /**
                 * Creates a new StyleTrait instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.StyleTrait
                 * @static
                 * @param {snapchat.bitmoji.api.IStyleTrait=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.StyleTrait} StyleTrait instance
                 */
                StyleTrait.create = function create(properties) {
                    return new StyleTrait(properties);
                };

                /**
                 * Decodes a StyleTrait message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.StyleTrait
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.StyleTrait} StyleTrait
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StyleTrait.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.StyleTrait();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.categories = $root.snapchat.bitmoji.api.TraitCategories.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return StyleTrait;
            })();

            api.GenderTrait = (function() {

                /**
                 * Properties of a GenderTrait.
                 * @memberof snapchat.bitmoji.api
                 * @interface IGenderTrait
                 * @property {snapchat.bitmoji.api.IStyleTrait|null} [cm] GenderTrait cm
                 * @property {snapchat.bitmoji.api.IStyleTrait|null} [bitstrips] GenderTrait bitstrips
                 * @property {snapchat.bitmoji.api.IStyleTrait|null} [bitmoji] GenderTrait bitmoji
                 */

                /**
                 * Constructs a new GenderTrait.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a GenderTrait.
                 * @implements IGenderTrait
                 * @constructor
                 * @param {snapchat.bitmoji.api.IGenderTrait=} [properties] Properties to set
                 */
                function GenderTrait(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GenderTrait cm.
                 * @member {snapchat.bitmoji.api.IStyleTrait|null|undefined} cm
                 * @memberof snapchat.bitmoji.api.GenderTrait
                 * @instance
                 */
                GenderTrait.prototype.cm = null;

                /**
                 * GenderTrait bitstrips.
                 * @member {snapchat.bitmoji.api.IStyleTrait|null|undefined} bitstrips
                 * @memberof snapchat.bitmoji.api.GenderTrait
                 * @instance
                 */
                GenderTrait.prototype.bitstrips = null;

                /**
                 * GenderTrait bitmoji.
                 * @member {snapchat.bitmoji.api.IStyleTrait|null|undefined} bitmoji
                 * @memberof snapchat.bitmoji.api.GenderTrait
                 * @instance
                 */
                GenderTrait.prototype.bitmoji = null;

                /**
                 * Creates a new GenderTrait instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.GenderTrait
                 * @static
                 * @param {snapchat.bitmoji.api.IGenderTrait=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.GenderTrait} GenderTrait instance
                 */
                GenderTrait.create = function create(properties) {
                    return new GenderTrait(properties);
                };

                /**
                 * Decodes a GenderTrait message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.GenderTrait
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.GenderTrait} GenderTrait
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GenderTrait.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.GenderTrait();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.cm = $root.snapchat.bitmoji.api.StyleTrait.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.bitstrips = $root.snapchat.bitmoji.api.StyleTrait.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.bitmoji = $root.snapchat.bitmoji.api.StyleTrait.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return GenderTrait;
            })();

            api.Traits = (function() {

                /**
                 * Properties of a Traits.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITraits
                 * @property {snapchat.bitmoji.api.ITraitMetadata|null} [metadata] Traits metadata
                 * @property {snapchat.bitmoji.api.IGenderTrait|null} [female] Traits female
                 * @property {snapchat.bitmoji.api.IGenderTrait|null} [male] Traits male
                 */

                /**
                 * Constructs a new Traits.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a Traits.
                 * @implements ITraits
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITraits=} [properties] Properties to set
                 */
                function Traits(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Traits metadata.
                 * @member {snapchat.bitmoji.api.ITraitMetadata|null|undefined} metadata
                 * @memberof snapchat.bitmoji.api.Traits
                 * @instance
                 */
                Traits.prototype.metadata = null;

                /**
                 * Traits female.
                 * @member {snapchat.bitmoji.api.IGenderTrait|null|undefined} female
                 * @memberof snapchat.bitmoji.api.Traits
                 * @instance
                 */
                Traits.prototype.female = null;

                /**
                 * Traits male.
                 * @member {snapchat.bitmoji.api.IGenderTrait|null|undefined} male
                 * @memberof snapchat.bitmoji.api.Traits
                 * @instance
                 */
                Traits.prototype.male = null;

                /**
                 * Creates a new Traits instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.Traits
                 * @static
                 * @param {snapchat.bitmoji.api.ITraits=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.Traits} Traits instance
                 */
                Traits.create = function create(properties) {
                    return new Traits(properties);
                };

                /**
                 * Decodes a Traits message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.Traits
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.Traits} Traits
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Traits.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.Traits();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.metadata = $root.snapchat.bitmoji.api.TraitMetadata.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.female = $root.snapchat.bitmoji.api.GenderTrait.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.male = $root.snapchat.bitmoji.api.GenderTrait.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return Traits;
            })();

            api.DefaultOptions = (function() {

                /**
                 * Properties of a DefaultOptions.
                 * @memberof snapchat.bitmoji.api
                 * @interface IDefaultOptions
                 * @property {number|null} [skin_tone] DefaultOptions skin_tone
                 * @property {number|null} [hair_tone] DefaultOptions hair_tone
                 * @property {number|null} [hair] DefaultOptions hair
                 * @property {number|null} [jaw] DefaultOptions jaw
                 * @property {number|null} [brow] DefaultOptions brow
                 * @property {number|null} [eye] DefaultOptions eye
                 * @property {number|null} [pupil] DefaultOptions pupil
                 * @property {number|null} [pupil_tone] DefaultOptions pupil_tone
                 * @property {number|null} [nose] DefaultOptions nose
                 * @property {number|null} [mouth] DefaultOptions mouth
                 * @property {number|null} [ear] DefaultOptions ear
                 * @property {number|null} [body] DefaultOptions body
                 * @property {number|null} [breast] DefaultOptions breast
                 * @property {number|null} [face_proportion] DefaultOptions face_proportion
                 * @property {number|null} [outfit] DefaultOptions outfit
                 * @property {number|null} [eye_spacing] DefaultOptions eye_spacing
                 * @property {number|null} [eye_size] DefaultOptions eye_size
                 * @property {number|null} [eyelash] DefaultOptions eyelash
                 */

                /**
                 * Constructs a new DefaultOptions.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a DefaultOptions.
                 * @implements IDefaultOptions
                 * @constructor
                 * @param {snapchat.bitmoji.api.IDefaultOptions=} [properties] Properties to set
                 */
                function DefaultOptions(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DefaultOptions skin_tone.
                 * @member {number} skin_tone
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.skin_tone = 0;

                /**
                 * DefaultOptions hair_tone.
                 * @member {number} hair_tone
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.hair_tone = 0;

                /**
                 * DefaultOptions hair.
                 * @member {number} hair
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.hair = 0;

                /**
                 * DefaultOptions jaw.
                 * @member {number} jaw
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.jaw = 0;

                /**
                 * DefaultOptions brow.
                 * @member {number} brow
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.brow = 0;

                /**
                 * DefaultOptions eye.
                 * @member {number} eye
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.eye = 0;

                /**
                 * DefaultOptions pupil.
                 * @member {number} pupil
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.pupil = 0;

                /**
                 * DefaultOptions pupil_tone.
                 * @member {number} pupil_tone
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.pupil_tone = 0;

                /**
                 * DefaultOptions nose.
                 * @member {number} nose
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.nose = 0;

                /**
                 * DefaultOptions mouth.
                 * @member {number} mouth
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.mouth = 0;

                /**
                 * DefaultOptions ear.
                 * @member {number} ear
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.ear = 0;

                /**
                 * DefaultOptions body.
                 * @member {number} body
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.body = 0;

                /**
                 * DefaultOptions breast.
                 * @member {number} breast
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.breast = 0;

                /**
                 * DefaultOptions face_proportion.
                 * @member {number} face_proportion
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.face_proportion = 0;

                /**
                 * DefaultOptions outfit.
                 * @member {number} outfit
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.outfit = 0;

                /**
                 * DefaultOptions eye_spacing.
                 * @member {number} eye_spacing
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.eye_spacing = 0;

                /**
                 * DefaultOptions eye_size.
                 * @member {number} eye_size
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.eye_size = 0;

                /**
                 * DefaultOptions eyelash.
                 * @member {number} eyelash
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @instance
                 */
                DefaultOptions.prototype.eyelash = 0;

                /**
                 * Creates a new DefaultOptions instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @static
                 * @param {snapchat.bitmoji.api.IDefaultOptions=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.DefaultOptions} DefaultOptions instance
                 */
                DefaultOptions.create = function create(properties) {
                    return new DefaultOptions(properties);
                };

                /**
                 * Decodes a DefaultOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.DefaultOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.DefaultOptions} DefaultOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DefaultOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.DefaultOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.skin_tone = reader.int32();
                            break;
                        case 2:
                            message.hair_tone = reader.int32();
                            break;
                        case 3:
                            message.hair = reader.int32();
                            break;
                        case 4:
                            message.jaw = reader.int32();
                            break;
                        case 5:
                            message.brow = reader.int32();
                            break;
                        case 6:
                            message.eye = reader.int32();
                            break;
                        case 7:
                            message.pupil = reader.int32();
                            break;
                        case 8:
                            message.pupil_tone = reader.int32();
                            break;
                        case 9:
                            message.nose = reader.int32();
                            break;
                        case 10:
                            message.mouth = reader.int32();
                            break;
                        case 11:
                            message.ear = reader.int32();
                            break;
                        case 12:
                            message.body = reader.int32();
                            break;
                        case 13:
                            message.breast = reader.int32();
                            break;
                        case 14:
                            message.face_proportion = reader.int32();
                            break;
                        case 15:
                            message.outfit = reader.int32();
                            break;
                        case 16:
                            message.eye_spacing = reader.int32();
                            break;
                        case 17:
                            message.eye_size = reader.int32();
                            break;
                        case 18:
                            message.eyelash = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return DefaultOptions;
            })();

            api.StyleDefault = (function() {

                /**
                 * Properties of a StyleDefault.
                 * @memberof snapchat.bitmoji.api
                 * @interface IStyleDefault
                 * @property {snapchat.bitmoji.api.IDefaultOptions|null} [option_ids] StyleDefault option_ids
                 */

                /**
                 * Constructs a new StyleDefault.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a StyleDefault.
                 * @implements IStyleDefault
                 * @constructor
                 * @param {snapchat.bitmoji.api.IStyleDefault=} [properties] Properties to set
                 */
                function StyleDefault(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StyleDefault option_ids.
                 * @member {snapchat.bitmoji.api.IDefaultOptions|null|undefined} option_ids
                 * @memberof snapchat.bitmoji.api.StyleDefault
                 * @instance
                 */
                StyleDefault.prototype.option_ids = null;

                /**
                 * Creates a new StyleDefault instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.StyleDefault
                 * @static
                 * @param {snapchat.bitmoji.api.IStyleDefault=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.StyleDefault} StyleDefault instance
                 */
                StyleDefault.create = function create(properties) {
                    return new StyleDefault(properties);
                };

                /**
                 * Decodes a StyleDefault message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.StyleDefault
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.StyleDefault} StyleDefault
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StyleDefault.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.StyleDefault();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.option_ids = $root.snapchat.bitmoji.api.DefaultOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return StyleDefault;
            })();

            api.GenderDefault = (function() {

                /**
                 * Properties of a GenderDefault.
                 * @memberof snapchat.bitmoji.api
                 * @interface IGenderDefault
                 * @property {snapchat.bitmoji.api.IStyleDefault|null} [cm] GenderDefault cm
                 * @property {snapchat.bitmoji.api.IStyleDefault|null} [bitstrips] GenderDefault bitstrips
                 * @property {snapchat.bitmoji.api.IStyleDefault|null} [bitmoji] GenderDefault bitmoji
                 */

                /**
                 * Constructs a new GenderDefault.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a GenderDefault.
                 * @implements IGenderDefault
                 * @constructor
                 * @param {snapchat.bitmoji.api.IGenderDefault=} [properties] Properties to set
                 */
                function GenderDefault(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GenderDefault cm.
                 * @member {snapchat.bitmoji.api.IStyleDefault|null|undefined} cm
                 * @memberof snapchat.bitmoji.api.GenderDefault
                 * @instance
                 */
                GenderDefault.prototype.cm = null;

                /**
                 * GenderDefault bitstrips.
                 * @member {snapchat.bitmoji.api.IStyleDefault|null|undefined} bitstrips
                 * @memberof snapchat.bitmoji.api.GenderDefault
                 * @instance
                 */
                GenderDefault.prototype.bitstrips = null;

                /**
                 * GenderDefault bitmoji.
                 * @member {snapchat.bitmoji.api.IStyleDefault|null|undefined} bitmoji
                 * @memberof snapchat.bitmoji.api.GenderDefault
                 * @instance
                 */
                GenderDefault.prototype.bitmoji = null;

                /**
                 * Creates a new GenderDefault instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.GenderDefault
                 * @static
                 * @param {snapchat.bitmoji.api.IGenderDefault=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.GenderDefault} GenderDefault instance
                 */
                GenderDefault.create = function create(properties) {
                    return new GenderDefault(properties);
                };

                /**
                 * Decodes a GenderDefault message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.GenderDefault
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.GenderDefault} GenderDefault
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GenderDefault.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.GenderDefault();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.cm = $root.snapchat.bitmoji.api.StyleDefault.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.bitstrips = $root.snapchat.bitmoji.api.StyleDefault.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.bitmoji = $root.snapchat.bitmoji.api.StyleDefault.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return GenderDefault;
            })();

            api.Defaults = (function() {

                /**
                 * Properties of a Defaults.
                 * @memberof snapchat.bitmoji.api
                 * @interface IDefaults
                 * @property {snapchat.bitmoji.api.IGenderDefault|null} [female] Defaults female
                 * @property {snapchat.bitmoji.api.IGenderDefault|null} [male] Defaults male
                 */

                /**
                 * Constructs a new Defaults.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a Defaults.
                 * @implements IDefaults
                 * @constructor
                 * @param {snapchat.bitmoji.api.IDefaults=} [properties] Properties to set
                 */
                function Defaults(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Defaults female.
                 * @member {snapchat.bitmoji.api.IGenderDefault|null|undefined} female
                 * @memberof snapchat.bitmoji.api.Defaults
                 * @instance
                 */
                Defaults.prototype.female = null;

                /**
                 * Defaults male.
                 * @member {snapchat.bitmoji.api.IGenderDefault|null|undefined} male
                 * @memberof snapchat.bitmoji.api.Defaults
                 * @instance
                 */
                Defaults.prototype.male = null;

                /**
                 * Creates a new Defaults instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.Defaults
                 * @static
                 * @param {snapchat.bitmoji.api.IDefaults=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.Defaults} Defaults instance
                 */
                Defaults.create = function create(properties) {
                    return new Defaults(properties);
                };

                /**
                 * Decodes a Defaults message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.Defaults
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.Defaults} Defaults
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Defaults.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.Defaults();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.female = $root.snapchat.bitmoji.api.GenderDefault.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.male = $root.snapchat.bitmoji.api.GenderDefault.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return Defaults;
            })();

            api.DetailedOutfitsOptions = (function() {

                /**
                 * Properties of a DetailedOutfitsOptions.
                 * @memberof snapchat.bitmoji.api
                 * @interface IDetailedOutfitsOptions
                 * @property {number|null} [top_tone1] DetailedOutfitsOptions top_tone1
                 * @property {number|null} [top_tone2] DetailedOutfitsOptions top_tone2
                 * @property {number|null} [top_tone3] DetailedOutfitsOptions top_tone3
                 * @property {number|null} [top_tone4] DetailedOutfitsOptions top_tone4
                 * @property {number|null} [top_tone5] DetailedOutfitsOptions top_tone5
                 * @property {number|null} [top_tone6] DetailedOutfitsOptions top_tone6
                 * @property {number|null} [top_tone7] DetailedOutfitsOptions top_tone7
                 * @property {number|null} [top_tone8] DetailedOutfitsOptions top_tone8
                 * @property {number|null} [top_tone9] DetailedOutfitsOptions top_tone9
                 * @property {number|null} [top_tone10] DetailedOutfitsOptions top_tone10
                 * @property {number|null} [bottom_tone1] DetailedOutfitsOptions bottom_tone1
                 * @property {number|null} [bottom_tone2] DetailedOutfitsOptions bottom_tone2
                 * @property {number|null} [bottom_tone3] DetailedOutfitsOptions bottom_tone3
                 * @property {number|null} [bottom_tone4] DetailedOutfitsOptions bottom_tone4
                 * @property {number|null} [bottom_tone5] DetailedOutfitsOptions bottom_tone5
                 * @property {number|null} [bottom_tone6] DetailedOutfitsOptions bottom_tone6
                 * @property {number|null} [bottom_tone7] DetailedOutfitsOptions bottom_tone7
                 * @property {number|null} [bottom_tone8] DetailedOutfitsOptions bottom_tone8
                 * @property {number|null} [bottom_tone9] DetailedOutfitsOptions bottom_tone9
                 * @property {number|null} [bottom_tone10] DetailedOutfitsOptions bottom_tone10
                 * @property {number|null} [footwear_tone1] DetailedOutfitsOptions footwear_tone1
                 * @property {number|null} [footwear_tone2] DetailedOutfitsOptions footwear_tone2
                 * @property {number|null} [footwear_tone3] DetailedOutfitsOptions footwear_tone3
                 * @property {number|null} [footwear_tone4] DetailedOutfitsOptions footwear_tone4
                 * @property {number|null} [footwear_tone5] DetailedOutfitsOptions footwear_tone5
                 * @property {number|null} [footwear_tone6] DetailedOutfitsOptions footwear_tone6
                 * @property {number|null} [footwear_tone7] DetailedOutfitsOptions footwear_tone7
                 * @property {number|null} [footwear_tone8] DetailedOutfitsOptions footwear_tone8
                 * @property {number|null} [footwear_tone9] DetailedOutfitsOptions footwear_tone9
                 * @property {number|null} [footwear_tone10] DetailedOutfitsOptions footwear_tone10
                 * @property {number|null} [outerwear_tone1] DetailedOutfitsOptions outerwear_tone1
                 * @property {number|null} [outerwear_tone2] DetailedOutfitsOptions outerwear_tone2
                 * @property {number|null} [outerwear_tone3] DetailedOutfitsOptions outerwear_tone3
                 * @property {number|null} [outerwear_tone4] DetailedOutfitsOptions outerwear_tone4
                 * @property {number|null} [outerwear_tone5] DetailedOutfitsOptions outerwear_tone5
                 * @property {number|null} [outerwear_tone6] DetailedOutfitsOptions outerwear_tone6
                 * @property {number|null} [outerwear_tone7] DetailedOutfitsOptions outerwear_tone7
                 * @property {number|null} [outerwear_tone8] DetailedOutfitsOptions outerwear_tone8
                 * @property {number|null} [outerwear_tone9] DetailedOutfitsOptions outerwear_tone9
                 * @property {number|null} [outerwear_tone10] DetailedOutfitsOptions outerwear_tone10
                 * @property {number|null} [is_tucked] DetailedOutfitsOptions is_tucked
                 * @property {number|null} [bottom] DetailedOutfitsOptions bottom
                 * @property {number|null} [top] DetailedOutfitsOptions top
                 * @property {number|null} [footwear] DetailedOutfitsOptions footwear
                 * @property {number|null} [sock] DetailedOutfitsOptions sock
                 * @property {number|null} [sock_tone1] DetailedOutfitsOptions sock_tone1
                 * @property {number|null} [sock_tone2] DetailedOutfitsOptions sock_tone2
                 * @property {number|null} [sock_tone3] DetailedOutfitsOptions sock_tone3
                 * @property {number|null} [sock_tone4] DetailedOutfitsOptions sock_tone4
                 * @property {number|null} [outerwear] DetailedOutfitsOptions outerwear
                 */

                /**
                 * Constructs a new DetailedOutfitsOptions.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a DetailedOutfitsOptions.
                 * @implements IDetailedOutfitsOptions
                 * @constructor
                 * @param {snapchat.bitmoji.api.IDetailedOutfitsOptions=} [properties] Properties to set
                 */
                function DetailedOutfitsOptions(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DetailedOutfitsOptions top_tone1.
                 * @member {number} top_tone1
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone1 = 0;

                /**
                 * DetailedOutfitsOptions top_tone2.
                 * @member {number} top_tone2
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone2 = 0;

                /**
                 * DetailedOutfitsOptions top_tone3.
                 * @member {number} top_tone3
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone3 = 0;

                /**
                 * DetailedOutfitsOptions top_tone4.
                 * @member {number} top_tone4
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone4 = 0;

                /**
                 * DetailedOutfitsOptions top_tone5.
                 * @member {number} top_tone5
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone5 = 0;

                /**
                 * DetailedOutfitsOptions top_tone6.
                 * @member {number} top_tone6
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone6 = 0;

                /**
                 * DetailedOutfitsOptions top_tone7.
                 * @member {number} top_tone7
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone7 = 0;

                /**
                 * DetailedOutfitsOptions top_tone8.
                 * @member {number} top_tone8
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone8 = 0;

                /**
                 * DetailedOutfitsOptions top_tone9.
                 * @member {number} top_tone9
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone9 = 0;

                /**
                 * DetailedOutfitsOptions top_tone10.
                 * @member {number} top_tone10
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top_tone10 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone1.
                 * @member {number} bottom_tone1
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone1 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone2.
                 * @member {number} bottom_tone2
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone2 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone3.
                 * @member {number} bottom_tone3
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone3 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone4.
                 * @member {number} bottom_tone4
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone4 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone5.
                 * @member {number} bottom_tone5
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone5 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone6.
                 * @member {number} bottom_tone6
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone6 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone7.
                 * @member {number} bottom_tone7
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone7 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone8.
                 * @member {number} bottom_tone8
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone8 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone9.
                 * @member {number} bottom_tone9
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone9 = 0;

                /**
                 * DetailedOutfitsOptions bottom_tone10.
                 * @member {number} bottom_tone10
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom_tone10 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone1.
                 * @member {number} footwear_tone1
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone1 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone2.
                 * @member {number} footwear_tone2
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone2 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone3.
                 * @member {number} footwear_tone3
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone3 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone4.
                 * @member {number} footwear_tone4
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone4 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone5.
                 * @member {number} footwear_tone5
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone5 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone6.
                 * @member {number} footwear_tone6
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone6 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone7.
                 * @member {number} footwear_tone7
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone7 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone8.
                 * @member {number} footwear_tone8
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone8 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone9.
                 * @member {number} footwear_tone9
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone9 = 0;

                /**
                 * DetailedOutfitsOptions footwear_tone10.
                 * @member {number} footwear_tone10
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear_tone10 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone1.
                 * @member {number} outerwear_tone1
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone1 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone2.
                 * @member {number} outerwear_tone2
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone2 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone3.
                 * @member {number} outerwear_tone3
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone3 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone4.
                 * @member {number} outerwear_tone4
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone4 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone5.
                 * @member {number} outerwear_tone5
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone5 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone6.
                 * @member {number} outerwear_tone6
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone6 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone7.
                 * @member {number} outerwear_tone7
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone7 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone8.
                 * @member {number} outerwear_tone8
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone8 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone9.
                 * @member {number} outerwear_tone9
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone9 = 0;

                /**
                 * DetailedOutfitsOptions outerwear_tone10.
                 * @member {number} outerwear_tone10
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear_tone10 = 0;

                /**
                 * DetailedOutfitsOptions is_tucked.
                 * @member {number} is_tucked
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.is_tucked = 0;

                /**
                 * DetailedOutfitsOptions bottom.
                 * @member {number} bottom
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.bottom = 0;

                /**
                 * DetailedOutfitsOptions top.
                 * @member {number} top
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.top = 0;

                /**
                 * DetailedOutfitsOptions footwear.
                 * @member {number} footwear
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.footwear = 0;

                /**
                 * DetailedOutfitsOptions sock.
                 * @member {number} sock
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.sock = 0;

                /**
                 * DetailedOutfitsOptions sock_tone1.
                 * @member {number} sock_tone1
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.sock_tone1 = 0;

                /**
                 * DetailedOutfitsOptions sock_tone2.
                 * @member {number} sock_tone2
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.sock_tone2 = 0;

                /**
                 * DetailedOutfitsOptions sock_tone3.
                 * @member {number} sock_tone3
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.sock_tone3 = 0;

                /**
                 * DetailedOutfitsOptions sock_tone4.
                 * @member {number} sock_tone4
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.sock_tone4 = 0;

                /**
                 * DetailedOutfitsOptions outerwear.
                 * @member {number} outerwear
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                DetailedOutfitsOptions.prototype.outerwear = 0;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * DetailedOutfitsOptions top_tone1_outfit.
                 * @member {"top_tone1"|undefined} top_tone1_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone1_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone2_outfit.
                 * @member {"top_tone2"|undefined} top_tone2_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone2_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone3_outfit.
                 * @member {"top_tone3"|undefined} top_tone3_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone3_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone4_outfit.
                 * @member {"top_tone4"|undefined} top_tone4_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone4_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone5_outfit.
                 * @member {"top_tone5"|undefined} top_tone5_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone5_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone6_outfit.
                 * @member {"top_tone6"|undefined} top_tone6_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone6_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone7_outfit.
                 * @member {"top_tone7"|undefined} top_tone7_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone7_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone8_outfit.
                 * @member {"top_tone8"|undefined} top_tone8_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone8_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone9_outfit.
                 * @member {"top_tone9"|undefined} top_tone9_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone9_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_tone10_outfit.
                 * @member {"top_tone10"|undefined} top_tone10_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_tone10_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone1_outfit.
                 * @member {"bottom_tone1"|undefined} bottom_tone1_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone1_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone2_outfit.
                 * @member {"bottom_tone2"|undefined} bottom_tone2_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone2_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone3_outfit.
                 * @member {"bottom_tone3"|undefined} bottom_tone3_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone3_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone4_outfit.
                 * @member {"bottom_tone4"|undefined} bottom_tone4_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone4_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone5_outfit.
                 * @member {"bottom_tone5"|undefined} bottom_tone5_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone5_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone6_outfit.
                 * @member {"bottom_tone6"|undefined} bottom_tone6_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone6_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone7_outfit.
                 * @member {"bottom_tone7"|undefined} bottom_tone7_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone7_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone8_outfit.
                 * @member {"bottom_tone8"|undefined} bottom_tone8_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone8_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone9_outfit.
                 * @member {"bottom_tone9"|undefined} bottom_tone9_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone9_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_tone10_outfit.
                 * @member {"bottom_tone10"|undefined} bottom_tone10_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_tone10_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone1_outfit.
                 * @member {"footwear_tone1"|undefined} footwear_tone1_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone1_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone2_outfit.
                 * @member {"footwear_tone2"|undefined} footwear_tone2_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone2_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone3_outfit.
                 * @member {"footwear_tone3"|undefined} footwear_tone3_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone3_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone4_outfit.
                 * @member {"footwear_tone4"|undefined} footwear_tone4_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone4_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone5_outfit.
                 * @member {"footwear_tone5"|undefined} footwear_tone5_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone5_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone6_outfit.
                 * @member {"footwear_tone6"|undefined} footwear_tone6_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone6_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone7_outfit.
                 * @member {"footwear_tone7"|undefined} footwear_tone7_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone7_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone8_outfit.
                 * @member {"footwear_tone8"|undefined} footwear_tone8_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone8_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone9_outfit.
                 * @member {"footwear_tone9"|undefined} footwear_tone9_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone9_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_tone10_outfit.
                 * @member {"footwear_tone10"|undefined} footwear_tone10_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_tone10_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone1_outfit.
                 * @member {"outerwear_tone1"|undefined} outerwear_tone1_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone1_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone2_outfit.
                 * @member {"outerwear_tone2"|undefined} outerwear_tone2_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone2_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone3_outfit.
                 * @member {"outerwear_tone3"|undefined} outerwear_tone3_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone3_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone4_outfit.
                 * @member {"outerwear_tone4"|undefined} outerwear_tone4_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone4_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone5_outfit.
                 * @member {"outerwear_tone5"|undefined} outerwear_tone5_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone5_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone6_outfit.
                 * @member {"outerwear_tone6"|undefined} outerwear_tone6_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone6_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone7_outfit.
                 * @member {"outerwear_tone7"|undefined} outerwear_tone7_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone7_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone8_outfit.
                 * @member {"outerwear_tone8"|undefined} outerwear_tone8_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone8_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone9_outfit.
                 * @member {"outerwear_tone9"|undefined} outerwear_tone9_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone9_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_tone10_outfit.
                 * @member {"outerwear_tone10"|undefined} outerwear_tone10_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_tone10_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions is_tucked_outfit.
                 * @member {"is_tucked"|undefined} is_tucked_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "is_tucked_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["is_tucked"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions bottom_outfit.
                 * @member {"bottom"|undefined} bottom_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "bottom_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions top_outfit.
                 * @member {"top"|undefined} top_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "top_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["top"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions footwear_outfit.
                 * @member {"footwear"|undefined} footwear_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "footwear_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions sock_outfit.
                 * @member {"sock"|undefined} sock_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "sock_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["sock"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions sock_tone1_outfit.
                 * @member {"sock_tone1"|undefined} sock_tone1_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "sock_tone1_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions sock_tone2_outfit.
                 * @member {"sock_tone2"|undefined} sock_tone2_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "sock_tone2_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions sock_tone3_outfit.
                 * @member {"sock_tone3"|undefined} sock_tone3_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "sock_tone3_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions sock_tone4_outfit.
                 * @member {"sock_tone4"|undefined} sock_tone4_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "sock_tone4_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * DetailedOutfitsOptions outerwear_outfit.
                 * @member {"outerwear"|undefined} outerwear_outfit
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @instance
                 */
                Object.defineProperty(DetailedOutfitsOptions.prototype, "outerwear_outfit", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DetailedOutfitsOptions instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @static
                 * @param {snapchat.bitmoji.api.IDetailedOutfitsOptions=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.DetailedOutfitsOptions} DetailedOutfitsOptions instance
                 */
                DetailedOutfitsOptions.create = function create(properties) {
                    return new DetailedOutfitsOptions(properties);
                };

                /**
                 * Decodes a DetailedOutfitsOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.DetailedOutfitsOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.DetailedOutfitsOptions} DetailedOutfitsOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DetailedOutfitsOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.DetailedOutfitsOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.top_tone1 = reader.int32();
                            break;
                        case 2:
                            message.top_tone2 = reader.int32();
                            break;
                        case 3:
                            message.top_tone3 = reader.int32();
                            break;
                        case 4:
                            message.top_tone4 = reader.int32();
                            break;
                        case 5:
                            message.top_tone5 = reader.int32();
                            break;
                        case 6:
                            message.top_tone6 = reader.int32();
                            break;
                        case 7:
                            message.top_tone7 = reader.int32();
                            break;
                        case 8:
                            message.top_tone8 = reader.int32();
                            break;
                        case 9:
                            message.top_tone9 = reader.int32();
                            break;
                        case 10:
                            message.top_tone10 = reader.int32();
                            break;
                        case 11:
                            message.bottom_tone1 = reader.int32();
                            break;
                        case 12:
                            message.bottom_tone2 = reader.int32();
                            break;
                        case 13:
                            message.bottom_tone3 = reader.int32();
                            break;
                        case 14:
                            message.bottom_tone4 = reader.int32();
                            break;
                        case 15:
                            message.bottom_tone5 = reader.int32();
                            break;
                        case 16:
                            message.bottom_tone6 = reader.int32();
                            break;
                        case 17:
                            message.bottom_tone7 = reader.int32();
                            break;
                        case 18:
                            message.bottom_tone8 = reader.int32();
                            break;
                        case 19:
                            message.bottom_tone9 = reader.int32();
                            break;
                        case 20:
                            message.bottom_tone10 = reader.int32();
                            break;
                        case 21:
                            message.footwear_tone1 = reader.int32();
                            break;
                        case 22:
                            message.footwear_tone2 = reader.int32();
                            break;
                        case 23:
                            message.footwear_tone3 = reader.int32();
                            break;
                        case 24:
                            message.footwear_tone4 = reader.int32();
                            break;
                        case 25:
                            message.footwear_tone5 = reader.int32();
                            break;
                        case 26:
                            message.footwear_tone6 = reader.int32();
                            break;
                        case 27:
                            message.footwear_tone7 = reader.int32();
                            break;
                        case 28:
                            message.footwear_tone8 = reader.int32();
                            break;
                        case 29:
                            message.footwear_tone9 = reader.int32();
                            break;
                        case 30:
                            message.footwear_tone10 = reader.int32();
                            break;
                        case 31:
                            message.outerwear_tone1 = reader.int32();
                            break;
                        case 32:
                            message.outerwear_tone2 = reader.int32();
                            break;
                        case 33:
                            message.outerwear_tone3 = reader.int32();
                            break;
                        case 34:
                            message.outerwear_tone4 = reader.int32();
                            break;
                        case 35:
                            message.outerwear_tone5 = reader.int32();
                            break;
                        case 36:
                            message.outerwear_tone6 = reader.int32();
                            break;
                        case 37:
                            message.outerwear_tone7 = reader.int32();
                            break;
                        case 38:
                            message.outerwear_tone8 = reader.int32();
                            break;
                        case 39:
                            message.outerwear_tone9 = reader.int32();
                            break;
                        case 40:
                            message.outerwear_tone10 = reader.int32();
                            break;
                        case 41:
                            message.is_tucked = reader.int32();
                            break;
                        case 42:
                            message.bottom = reader.int32();
                            break;
                        case 43:
                            message.top = reader.int32();
                            break;
                        case 44:
                            message.footwear = reader.int32();
                            break;
                        case 45:
                            message.sock = reader.int32();
                            break;
                        case 46:
                            message.sock_tone1 = reader.int32();
                            break;
                        case 47:
                            message.sock_tone2 = reader.int32();
                            break;
                        case 48:
                            message.sock_tone3 = reader.int32();
                            break;
                        case 49:
                            message.sock_tone4 = reader.int32();
                            break;
                        case 50:
                            message.outerwear = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return DetailedOutfitsOptions;
            })();

            api.IndividualOutfit = (function() {

                /**
                 * Properties of an IndividualOutfit.
                 * @memberof snapchat.bitmoji.api
                 * @interface IIndividualOutfit
                 * @property {number|null} [id] IndividualOutfit id
                 * @property {string|null} [outfit] IndividualOutfit outfit
                 * @property {boolean|null} [has_custom_head] IndividualOutfit has_custom_head
                 * @property {string|null} [sublogo] IndividualOutfit sublogo
                 * @property {string|null} [description] IndividualOutfit description
                 * @property {string|null} [image] IndividualOutfit image
                 * @property {number|null} [outfit_type] IndividualOutfit outfit_type
                 * @property {snapchat.bitmoji.api.IDetailedOutfitsOptions|null} [detailed_options] IndividualOutfit detailed_options
                 */

                /**
                 * Constructs a new IndividualOutfit.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents an IndividualOutfit.
                 * @implements IIndividualOutfit
                 * @constructor
                 * @param {snapchat.bitmoji.api.IIndividualOutfit=} [properties] Properties to set
                 */
                function IndividualOutfit(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * IndividualOutfit id.
                 * @member {number} id
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.id = 0;

                /**
                 * IndividualOutfit outfit.
                 * @member {string} outfit
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.outfit = "";

                /**
                 * IndividualOutfit has_custom_head.
                 * @member {boolean} has_custom_head
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.has_custom_head = false;

                /**
                 * IndividualOutfit sublogo.
                 * @member {string} sublogo
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.sublogo = "";

                /**
                 * IndividualOutfit description.
                 * @member {string} description
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.description = "";

                /**
                 * IndividualOutfit image.
                 * @member {string} image
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.image = "";

                /**
                 * IndividualOutfit outfit_type.
                 * @member {number} outfit_type
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.outfit_type = 0;

                /**
                 * IndividualOutfit detailed_options.
                 * @member {snapchat.bitmoji.api.IDetailedOutfitsOptions|null|undefined} detailed_options
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @instance
                 */
                IndividualOutfit.prototype.detailed_options = null;

                /**
                 * Creates a new IndividualOutfit instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @static
                 * @param {snapchat.bitmoji.api.IIndividualOutfit=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.IndividualOutfit} IndividualOutfit instance
                 */
                IndividualOutfit.create = function create(properties) {
                    return new IndividualOutfit(properties);
                };

                /**
                 * Decodes an IndividualOutfit message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.IndividualOutfit
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.IndividualOutfit} IndividualOutfit
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IndividualOutfit.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.IndividualOutfit();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int32();
                            break;
                        case 2:
                            message.outfit = reader.string();
                            break;
                        case 3:
                            message.has_custom_head = reader.bool();
                            break;
                        case 4:
                            message.sublogo = reader.string();
                            break;
                        case 5:
                            message.description = reader.string();
                            break;
                        case 6:
                            message.image = reader.string();
                            break;
                        case 7:
                            message.outfit_type = reader.int32();
                            break;
                        case 8:
                            message.detailed_options = $root.snapchat.bitmoji.api.DetailedOutfitsOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return IndividualOutfit;
            })();

            api.OutfitBrand = (function() {

                /**
                 * Properties of an OutfitBrand.
                 * @memberof snapchat.bitmoji.api
                 * @interface IOutfitBrand
                 * @property {number|null} [id] OutfitBrand id
                 * @property {string|null} [name] OutfitBrand name
                 * @property {string|null} [logo] OutfitBrand logo
                 * @property {string|null} [header_background] OutfitBrand header_background
                 * @property {string|null} [store_background] OutfitBrand store_background
                 * @property {string|null} [bg_color] OutfitBrand bg_color
                 * @property {string|null} [fg_color] OutfitBrand fg_color
                 * @property {string|null} [theme] OutfitBrand theme
                 * @property {boolean|null} [visible_in_snapchat] OutfitBrand visible_in_snapchat
                 * @property {Array.<snapchat.bitmoji.api.IIndividualOutfit>|null} [outfits] OutfitBrand outfits
                 */

                /**
                 * Constructs a new OutfitBrand.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents an OutfitBrand.
                 * @implements IOutfitBrand
                 * @constructor
                 * @param {snapchat.bitmoji.api.IOutfitBrand=} [properties] Properties to set
                 */
                function OutfitBrand(properties) {
                    this.outfits = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OutfitBrand id.
                 * @member {number} id
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.id = 0;

                /**
                 * OutfitBrand name.
                 * @member {string} name
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.name = "";

                /**
                 * OutfitBrand logo.
                 * @member {string} logo
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.logo = "";

                /**
                 * OutfitBrand header_background.
                 * @member {string} header_background
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.header_background = "";

                /**
                 * OutfitBrand store_background.
                 * @member {string} store_background
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.store_background = "";

                /**
                 * OutfitBrand bg_color.
                 * @member {string} bg_color
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.bg_color = "";

                /**
                 * OutfitBrand fg_color.
                 * @member {string} fg_color
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.fg_color = "";

                /**
                 * OutfitBrand theme.
                 * @member {string} theme
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.theme = "";

                /**
                 * OutfitBrand visible_in_snapchat.
                 * @member {boolean} visible_in_snapchat
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.visible_in_snapchat = false;

                /**
                 * OutfitBrand outfits.
                 * @member {Array.<snapchat.bitmoji.api.IIndividualOutfit>} outfits
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @instance
                 */
                OutfitBrand.prototype.outfits = $util.emptyArray;

                /**
                 * Creates a new OutfitBrand instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @static
                 * @param {snapchat.bitmoji.api.IOutfitBrand=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.OutfitBrand} OutfitBrand instance
                 */
                OutfitBrand.create = function create(properties) {
                    return new OutfitBrand(properties);
                };

                /**
                 * Decodes an OutfitBrand message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.OutfitBrand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.OutfitBrand} OutfitBrand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OutfitBrand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.OutfitBrand();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int32();
                            break;
                        case 2:
                            message.name = reader.string();
                            break;
                        case 3:
                            message.logo = reader.string();
                            break;
                        case 4:
                            message.header_background = reader.string();
                            break;
                        case 5:
                            message.store_background = reader.string();
                            break;
                        case 6:
                            message.bg_color = reader.string();
                            break;
                        case 7:
                            message.fg_color = reader.string();
                            break;
                        case 8:
                            message.theme = reader.string();
                            break;
                        case 9:
                            message.visible_in_snapchat = reader.bool();
                            break;
                        case 10:
                            if (!(message.outfits && message.outfits.length))
                                message.outfits = [];
                            message.outfits.push($root.snapchat.bitmoji.api.IndividualOutfit.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return OutfitBrand;
            })();

            api.GenderedOutfits = (function() {

                /**
                 * Properties of a GenderedOutfits.
                 * @memberof snapchat.bitmoji.api
                 * @interface IGenderedOutfits
                 * @property {Array.<snapchat.bitmoji.api.IOutfitBrand>|null} [brands] GenderedOutfits brands
                 */

                /**
                 * Constructs a new GenderedOutfits.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a GenderedOutfits.
                 * @implements IGenderedOutfits
                 * @constructor
                 * @param {snapchat.bitmoji.api.IGenderedOutfits=} [properties] Properties to set
                 */
                function GenderedOutfits(properties) {
                    this.brands = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GenderedOutfits brands.
                 * @member {Array.<snapchat.bitmoji.api.IOutfitBrand>} brands
                 * @memberof snapchat.bitmoji.api.GenderedOutfits
                 * @instance
                 */
                GenderedOutfits.prototype.brands = $util.emptyArray;

                /**
                 * Creates a new GenderedOutfits instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.GenderedOutfits
                 * @static
                 * @param {snapchat.bitmoji.api.IGenderedOutfits=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.GenderedOutfits} GenderedOutfits instance
                 */
                GenderedOutfits.create = function create(properties) {
                    return new GenderedOutfits(properties);
                };

                /**
                 * Decodes a GenderedOutfits message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.GenderedOutfits
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.GenderedOutfits} GenderedOutfits
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GenderedOutfits.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.GenderedOutfits();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.brands && message.brands.length))
                                message.brands = [];
                            message.brands.push($root.snapchat.bitmoji.api.OutfitBrand.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return GenderedOutfits;
            })();

            api.Outfits = (function() {

                /**
                 * Properties of an Outfits.
                 * @memberof snapchat.bitmoji.api
                 * @interface IOutfits
                 * @property {snapchat.bitmoji.api.IGenderedOutfits|null} [female] Outfits female
                 * @property {snapchat.bitmoji.api.IGenderedOutfits|null} [male] Outfits male
                 */

                /**
                 * Constructs a new Outfits.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents an Outfits.
                 * @implements IOutfits
                 * @constructor
                 * @param {snapchat.bitmoji.api.IOutfits=} [properties] Properties to set
                 */
                function Outfits(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Outfits female.
                 * @member {snapchat.bitmoji.api.IGenderedOutfits|null|undefined} female
                 * @memberof snapchat.bitmoji.api.Outfits
                 * @instance
                 */
                Outfits.prototype.female = null;

                /**
                 * Outfits male.
                 * @member {snapchat.bitmoji.api.IGenderedOutfits|null|undefined} male
                 * @memberof snapchat.bitmoji.api.Outfits
                 * @instance
                 */
                Outfits.prototype.male = null;

                /**
                 * Creates a new Outfits instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.Outfits
                 * @static
                 * @param {snapchat.bitmoji.api.IOutfits=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.Outfits} Outfits instance
                 */
                Outfits.create = function create(properties) {
                    return new Outfits(properties);
                };

                /**
                 * Decodes an Outfits message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.Outfits
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.Outfits} Outfits
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Outfits.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.Outfits();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.female = $root.snapchat.bitmoji.api.GenderedOutfits.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.male = $root.snapchat.bitmoji.api.GenderedOutfits.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return Outfits;
            })();

            api.Tone = (function() {

                /**
                 * Properties of a Tone.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITone
                 * @property {number|null} [top_tone1] Tone top_tone1
                 * @property {number|null} [top_tone2] Tone top_tone2
                 * @property {number|null} [top_tone3] Tone top_tone3
                 * @property {number|null} [top_tone4] Tone top_tone4
                 * @property {number|null} [top_tone5] Tone top_tone5
                 * @property {number|null} [top_tone6] Tone top_tone6
                 * @property {number|null} [top_tone7] Tone top_tone7
                 * @property {number|null} [top_tone8] Tone top_tone8
                 * @property {number|null} [top_tone9] Tone top_tone9
                 * @property {number|null} [top_tone10] Tone top_tone10
                 * @property {number|null} [bottom_tone1] Tone bottom_tone1
                 * @property {number|null} [bottom_tone2] Tone bottom_tone2
                 * @property {number|null} [bottom_tone3] Tone bottom_tone3
                 * @property {number|null} [bottom_tone4] Tone bottom_tone4
                 * @property {number|null} [bottom_tone5] Tone bottom_tone5
                 * @property {number|null} [bottom_tone6] Tone bottom_tone6
                 * @property {number|null} [bottom_tone7] Tone bottom_tone7
                 * @property {number|null} [bottom_tone8] Tone bottom_tone8
                 * @property {number|null} [bottom_tone9] Tone bottom_tone9
                 * @property {number|null} [bottom_tone10] Tone bottom_tone10
                 * @property {number|null} [footwear_tone1] Tone footwear_tone1
                 * @property {number|null} [footwear_tone2] Tone footwear_tone2
                 * @property {number|null} [footwear_tone3] Tone footwear_tone3
                 * @property {number|null} [footwear_tone4] Tone footwear_tone4
                 * @property {number|null} [footwear_tone5] Tone footwear_tone5
                 * @property {number|null} [footwear_tone6] Tone footwear_tone6
                 * @property {number|null} [footwear_tone7] Tone footwear_tone7
                 * @property {number|null} [footwear_tone8] Tone footwear_tone8
                 * @property {number|null} [footwear_tone9] Tone footwear_tone9
                 * @property {number|null} [footwear_tone10] Tone footwear_tone10
                 * @property {number|null} [outerwear_tone1] Tone outerwear_tone1
                 * @property {number|null} [outerwear_tone2] Tone outerwear_tone2
                 * @property {number|null} [outerwear_tone3] Tone outerwear_tone3
                 * @property {number|null} [outerwear_tone4] Tone outerwear_tone4
                 * @property {number|null} [outerwear_tone5] Tone outerwear_tone5
                 * @property {number|null} [outerwear_tone6] Tone outerwear_tone6
                 * @property {number|null} [outerwear_tone7] Tone outerwear_tone7
                 * @property {number|null} [outerwear_tone8] Tone outerwear_tone8
                 * @property {number|null} [outerwear_tone9] Tone outerwear_tone9
                 * @property {number|null} [outerwear_tone10] Tone outerwear_tone10
                 * @property {number|null} [sock_tone1] Tone sock_tone1
                 * @property {number|null} [sock_tone2] Tone sock_tone2
                 * @property {number|null} [sock_tone3] Tone sock_tone3
                 * @property {number|null} [sock_tone4] Tone sock_tone4
                 */

                /**
                 * Constructs a new Tone.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a Tone.
                 * @implements ITone
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITone=} [properties] Properties to set
                 */
                function Tone(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Tone top_tone1.
                 * @member {number} top_tone1
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone1 = 0;

                /**
                 * Tone top_tone2.
                 * @member {number} top_tone2
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone2 = 0;

                /**
                 * Tone top_tone3.
                 * @member {number} top_tone3
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone3 = 0;

                /**
                 * Tone top_tone4.
                 * @member {number} top_tone4
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone4 = 0;

                /**
                 * Tone top_tone5.
                 * @member {number} top_tone5
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone5 = 0;

                /**
                 * Tone top_tone6.
                 * @member {number} top_tone6
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone6 = 0;

                /**
                 * Tone top_tone7.
                 * @member {number} top_tone7
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone7 = 0;

                /**
                 * Tone top_tone8.
                 * @member {number} top_tone8
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone8 = 0;

                /**
                 * Tone top_tone9.
                 * @member {number} top_tone9
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone9 = 0;

                /**
                 * Tone top_tone10.
                 * @member {number} top_tone10
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.top_tone10 = 0;

                /**
                 * Tone bottom_tone1.
                 * @member {number} bottom_tone1
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone1 = 0;

                /**
                 * Tone bottom_tone2.
                 * @member {number} bottom_tone2
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone2 = 0;

                /**
                 * Tone bottom_tone3.
                 * @member {number} bottom_tone3
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone3 = 0;

                /**
                 * Tone bottom_tone4.
                 * @member {number} bottom_tone4
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone4 = 0;

                /**
                 * Tone bottom_tone5.
                 * @member {number} bottom_tone5
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone5 = 0;

                /**
                 * Tone bottom_tone6.
                 * @member {number} bottom_tone6
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone6 = 0;

                /**
                 * Tone bottom_tone7.
                 * @member {number} bottom_tone7
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone7 = 0;

                /**
                 * Tone bottom_tone8.
                 * @member {number} bottom_tone8
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone8 = 0;

                /**
                 * Tone bottom_tone9.
                 * @member {number} bottom_tone9
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone9 = 0;

                /**
                 * Tone bottom_tone10.
                 * @member {number} bottom_tone10
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.bottom_tone10 = 0;

                /**
                 * Tone footwear_tone1.
                 * @member {number} footwear_tone1
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone1 = 0;

                /**
                 * Tone footwear_tone2.
                 * @member {number} footwear_tone2
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone2 = 0;

                /**
                 * Tone footwear_tone3.
                 * @member {number} footwear_tone3
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone3 = 0;

                /**
                 * Tone footwear_tone4.
                 * @member {number} footwear_tone4
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone4 = 0;

                /**
                 * Tone footwear_tone5.
                 * @member {number} footwear_tone5
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone5 = 0;

                /**
                 * Tone footwear_tone6.
                 * @member {number} footwear_tone6
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone6 = 0;

                /**
                 * Tone footwear_tone7.
                 * @member {number} footwear_tone7
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone7 = 0;

                /**
                 * Tone footwear_tone8.
                 * @member {number} footwear_tone8
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone8 = 0;

                /**
                 * Tone footwear_tone9.
                 * @member {number} footwear_tone9
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone9 = 0;

                /**
                 * Tone footwear_tone10.
                 * @member {number} footwear_tone10
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.footwear_tone10 = 0;

                /**
                 * Tone outerwear_tone1.
                 * @member {number} outerwear_tone1
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone1 = 0;

                /**
                 * Tone outerwear_tone2.
                 * @member {number} outerwear_tone2
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone2 = 0;

                /**
                 * Tone outerwear_tone3.
                 * @member {number} outerwear_tone3
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone3 = 0;

                /**
                 * Tone outerwear_tone4.
                 * @member {number} outerwear_tone4
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone4 = 0;

                /**
                 * Tone outerwear_tone5.
                 * @member {number} outerwear_tone5
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone5 = 0;

                /**
                 * Tone outerwear_tone6.
                 * @member {number} outerwear_tone6
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone6 = 0;

                /**
                 * Tone outerwear_tone7.
                 * @member {number} outerwear_tone7
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone7 = 0;

                /**
                 * Tone outerwear_tone8.
                 * @member {number} outerwear_tone8
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone8 = 0;

                /**
                 * Tone outerwear_tone9.
                 * @member {number} outerwear_tone9
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone9 = 0;

                /**
                 * Tone outerwear_tone10.
                 * @member {number} outerwear_tone10
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.outerwear_tone10 = 0;

                /**
                 * Tone sock_tone1.
                 * @member {number} sock_tone1
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.sock_tone1 = 0;

                /**
                 * Tone sock_tone2.
                 * @member {number} sock_tone2
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.sock_tone2 = 0;

                /**
                 * Tone sock_tone3.
                 * @member {number} sock_tone3
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.sock_tone3 = 0;

                /**
                 * Tone sock_tone4.
                 * @member {number} sock_tone4
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Tone.prototype.sock_tone4 = 0;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Tone top_tone1_mix_and_match.
                 * @member {"top_tone1"|undefined} top_tone1_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone1_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone2_mix_and_match.
                 * @member {"top_tone2"|undefined} top_tone2_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone2_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone3_mix_and_match.
                 * @member {"top_tone3"|undefined} top_tone3_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone3_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone4_mix_and_match.
                 * @member {"top_tone4"|undefined} top_tone4_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone4_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone5_mix_and_match.
                 * @member {"top_tone5"|undefined} top_tone5_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone5_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone6_mix_and_match.
                 * @member {"top_tone6"|undefined} top_tone6_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone6_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone7_mix_and_match.
                 * @member {"top_tone7"|undefined} top_tone7_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone7_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone8_mix_and_match.
                 * @member {"top_tone8"|undefined} top_tone8_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone8_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone9_mix_and_match.
                 * @member {"top_tone9"|undefined} top_tone9_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone9_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone top_tone10_mix_and_match.
                 * @member {"top_tone10"|undefined} top_tone10_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "top_tone10_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["top_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone1_mix_and_match.
                 * @member {"bottom_tone1"|undefined} bottom_tone1_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone1_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone2_mix_and_match.
                 * @member {"bottom_tone2"|undefined} bottom_tone2_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone2_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone3_mix_and_match.
                 * @member {"bottom_tone3"|undefined} bottom_tone3_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone3_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone4_mix_and_match.
                 * @member {"bottom_tone4"|undefined} bottom_tone4_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone4_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone5_mix_and_match.
                 * @member {"bottom_tone5"|undefined} bottom_tone5_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone5_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone6_mix_and_match.
                 * @member {"bottom_tone6"|undefined} bottom_tone6_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone6_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone7_mix_and_match.
                 * @member {"bottom_tone7"|undefined} bottom_tone7_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone7_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone8_mix_and_match.
                 * @member {"bottom_tone8"|undefined} bottom_tone8_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone8_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone9_mix_and_match.
                 * @member {"bottom_tone9"|undefined} bottom_tone9_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone9_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone bottom_tone10_mix_and_match.
                 * @member {"bottom_tone10"|undefined} bottom_tone10_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "bottom_tone10_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["bottom_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone1_mix_and_match.
                 * @member {"footwear_tone1"|undefined} footwear_tone1_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone1_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone2_mix_and_match.
                 * @member {"footwear_tone2"|undefined} footwear_tone2_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone2_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone3_mix_and_match.
                 * @member {"footwear_tone3"|undefined} footwear_tone3_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone3_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone4_mix_and_match.
                 * @member {"footwear_tone4"|undefined} footwear_tone4_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone4_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone5_mix_and_match.
                 * @member {"footwear_tone5"|undefined} footwear_tone5_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone5_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone6_mix_and_match.
                 * @member {"footwear_tone6"|undefined} footwear_tone6_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone6_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone7_mix_and_match.
                 * @member {"footwear_tone7"|undefined} footwear_tone7_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone7_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone8_mix_and_match.
                 * @member {"footwear_tone8"|undefined} footwear_tone8_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone8_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone9_mix_and_match.
                 * @member {"footwear_tone9"|undefined} footwear_tone9_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone9_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone footwear_tone10_mix_and_match.
                 * @member {"footwear_tone10"|undefined} footwear_tone10_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "footwear_tone10_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["footwear_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone1_mix_and_match.
                 * @member {"outerwear_tone1"|undefined} outerwear_tone1_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone1_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone2_mix_and_match.
                 * @member {"outerwear_tone2"|undefined} outerwear_tone2_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone2_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone3_mix_and_match.
                 * @member {"outerwear_tone3"|undefined} outerwear_tone3_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone3_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone4_mix_and_match.
                 * @member {"outerwear_tone4"|undefined} outerwear_tone4_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone4_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone5_mix_and_match.
                 * @member {"outerwear_tone5"|undefined} outerwear_tone5_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone5_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone5"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone6_mix_and_match.
                 * @member {"outerwear_tone6"|undefined} outerwear_tone6_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone6_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone6"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone7_mix_and_match.
                 * @member {"outerwear_tone7"|undefined} outerwear_tone7_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone7_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone7"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone8_mix_and_match.
                 * @member {"outerwear_tone8"|undefined} outerwear_tone8_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone8_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone8"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone9_mix_and_match.
                 * @member {"outerwear_tone9"|undefined} outerwear_tone9_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone9_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone9"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone outerwear_tone10_mix_and_match.
                 * @member {"outerwear_tone10"|undefined} outerwear_tone10_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "outerwear_tone10_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["outerwear_tone10"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone sock_tone1_mix_and_match.
                 * @member {"sock_tone1"|undefined} sock_tone1_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "sock_tone1_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone1"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone sock_tone2_mix_and_match.
                 * @member {"sock_tone2"|undefined} sock_tone2_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "sock_tone2_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone2"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone sock_tone3_mix_and_match.
                 * @member {"sock_tone3"|undefined} sock_tone3_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "sock_tone3_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone3"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Tone sock_tone4_mix_and_match.
                 * @member {"sock_tone4"|undefined} sock_tone4_mix_and_match
                 * @memberof snapchat.bitmoji.api.Tone
                 * @instance
                 */
                Object.defineProperty(Tone.prototype, "sock_tone4_mix_and_match", {
                    get: $util.oneOfGetter($oneOfFields = ["sock_tone4"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Tone instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.Tone
                 * @static
                 * @param {snapchat.bitmoji.api.ITone=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.Tone} Tone instance
                 */
                Tone.create = function create(properties) {
                    return new Tone(properties);
                };

                /**
                 * Decodes a Tone message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.Tone
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.Tone} Tone
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Tone.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.Tone();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.top_tone1 = reader.int32();
                            break;
                        case 2:
                            message.top_tone2 = reader.int32();
                            break;
                        case 3:
                            message.top_tone3 = reader.int32();
                            break;
                        case 4:
                            message.top_tone4 = reader.int32();
                            break;
                        case 5:
                            message.top_tone5 = reader.int32();
                            break;
                        case 6:
                            message.top_tone6 = reader.int32();
                            break;
                        case 7:
                            message.top_tone7 = reader.int32();
                            break;
                        case 8:
                            message.top_tone8 = reader.int32();
                            break;
                        case 9:
                            message.top_tone9 = reader.int32();
                            break;
                        case 10:
                            message.top_tone10 = reader.int32();
                            break;
                        case 11:
                            message.bottom_tone1 = reader.int32();
                            break;
                        case 12:
                            message.bottom_tone2 = reader.int32();
                            break;
                        case 13:
                            message.bottom_tone3 = reader.int32();
                            break;
                        case 14:
                            message.bottom_tone4 = reader.int32();
                            break;
                        case 15:
                            message.bottom_tone5 = reader.int32();
                            break;
                        case 16:
                            message.bottom_tone6 = reader.int32();
                            break;
                        case 17:
                            message.bottom_tone7 = reader.int32();
                            break;
                        case 18:
                            message.bottom_tone8 = reader.int32();
                            break;
                        case 19:
                            message.bottom_tone9 = reader.int32();
                            break;
                        case 20:
                            message.bottom_tone10 = reader.int32();
                            break;
                        case 21:
                            message.footwear_tone1 = reader.int32();
                            break;
                        case 22:
                            message.footwear_tone2 = reader.int32();
                            break;
                        case 23:
                            message.footwear_tone3 = reader.int32();
                            break;
                        case 24:
                            message.footwear_tone4 = reader.int32();
                            break;
                        case 25:
                            message.footwear_tone5 = reader.int32();
                            break;
                        case 26:
                            message.footwear_tone6 = reader.int32();
                            break;
                        case 27:
                            message.footwear_tone7 = reader.int32();
                            break;
                        case 28:
                            message.footwear_tone8 = reader.int32();
                            break;
                        case 29:
                            message.footwear_tone9 = reader.int32();
                            break;
                        case 30:
                            message.footwear_tone10 = reader.int32();
                            break;
                        case 31:
                            message.outerwear_tone1 = reader.int32();
                            break;
                        case 32:
                            message.outerwear_tone2 = reader.int32();
                            break;
                        case 33:
                            message.outerwear_tone3 = reader.int32();
                            break;
                        case 34:
                            message.outerwear_tone4 = reader.int32();
                            break;
                        case 35:
                            message.outerwear_tone5 = reader.int32();
                            break;
                        case 36:
                            message.outerwear_tone6 = reader.int32();
                            break;
                        case 37:
                            message.outerwear_tone7 = reader.int32();
                            break;
                        case 38:
                            message.outerwear_tone8 = reader.int32();
                            break;
                        case 39:
                            message.outerwear_tone9 = reader.int32();
                            break;
                        case 40:
                            message.outerwear_tone10 = reader.int32();
                            break;
                        case 41:
                            message.sock_tone1 = reader.int32();
                            break;
                        case 42:
                            message.sock_tone2 = reader.int32();
                            break;
                        case 43:
                            message.sock_tone3 = reader.int32();
                            break;
                        case 44:
                            message.sock_tone4 = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return Tone;
            })();

            api.ColorGroupTones = (function() {

                /**
                 * Properties of a ColorGroupTones.
                 * @memberof snapchat.bitmoji.api
                 * @interface IColorGroupTones
                 * @property {Array.<snapchat.bitmoji.api.ITone>|null} [tones] ColorGroupTones tones
                 */

                /**
                 * Constructs a new ColorGroupTones.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a ColorGroupTones.
                 * @implements IColorGroupTones
                 * @constructor
                 * @param {snapchat.bitmoji.api.IColorGroupTones=} [properties] Properties to set
                 */
                function ColorGroupTones(properties) {
                    this.tones = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColorGroupTones tones.
                 * @member {Array.<snapchat.bitmoji.api.ITone>} tones
                 * @memberof snapchat.bitmoji.api.ColorGroupTones
                 * @instance
                 */
                ColorGroupTones.prototype.tones = $util.emptyArray;

                /**
                 * Creates a new ColorGroupTones instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.ColorGroupTones
                 * @static
                 * @param {snapchat.bitmoji.api.IColorGroupTones=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.ColorGroupTones} ColorGroupTones instance
                 */
                ColorGroupTones.create = function create(properties) {
                    return new ColorGroupTones(properties);
                };

                /**
                 * Decodes a ColorGroupTones message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.ColorGroupTones
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.ColorGroupTones} ColorGroupTones
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColorGroupTones.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.ColorGroupTones();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.tones && message.tones.length))
                                message.tones = [];
                            message.tones.push($root.snapchat.bitmoji.api.Tone.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return ColorGroupTones;
            })();

            api.TopsDefaultTuckState = (function() {

                /**
                 * Properties of a TopsDefaultTuckState.
                 * @memberof snapchat.bitmoji.api
                 * @interface ITopsDefaultTuckState
                 * @property {Object.<string,string>|null} [tuck_state] TopsDefaultTuckState tuck_state
                 */

                /**
                 * Constructs a new TopsDefaultTuckState.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a TopsDefaultTuckState.
                 * @implements ITopsDefaultTuckState
                 * @constructor
                 * @param {snapchat.bitmoji.api.ITopsDefaultTuckState=} [properties] Properties to set
                 */
                function TopsDefaultTuckState(properties) {
                    this.tuck_state = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TopsDefaultTuckState tuck_state.
                 * @member {Object.<string,string>} tuck_state
                 * @memberof snapchat.bitmoji.api.TopsDefaultTuckState
                 * @instance
                 */
                TopsDefaultTuckState.prototype.tuck_state = $util.emptyObject;

                /**
                 * Creates a new TopsDefaultTuckState instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.TopsDefaultTuckState
                 * @static
                 * @param {snapchat.bitmoji.api.ITopsDefaultTuckState=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.TopsDefaultTuckState} TopsDefaultTuckState instance
                 */
                TopsDefaultTuckState.create = function create(properties) {
                    return new TopsDefaultTuckState(properties);
                };

                /**
                 * Decodes a TopsDefaultTuckState message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.TopsDefaultTuckState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.TopsDefaultTuckState} TopsDefaultTuckState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TopsDefaultTuckState.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.TopsDefaultTuckState(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (message.tuck_state === $util.emptyObject)
                                message.tuck_state = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = "";
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.tuck_state[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return TopsDefaultTuckState;
            })();

            api.MixAndMatchItemsMetadata = (function() {

                /**
                 * Properties of a MixAndMatchItemsMetadata.
                 * @memberof snapchat.bitmoji.api
                 * @interface IMixAndMatchItemsMetadata
                 * @property {Object.<string,snapchat.bitmoji.api.IColorGroupTones>|null} [color_group_swatch_sets] MixAndMatchItemsMetadata color_group_swatch_sets
                 * @property {Object.<string,snapchat.bitmoji.api.ITopsDefaultTuckState>|null} [tops_default_tuck_state] MixAndMatchItemsMetadata tops_default_tuck_state
                 * @property {Object.<string,boolean>|null} [bottoms_tuckable] MixAndMatchItemsMetadata bottoms_tuckable
                 * @property {Object.<string,boolean>|null} [bodysuits] MixAndMatchItemsMetadata bodysuits
                 * @property {Object.<string,boolean>|null} [one_pieces] MixAndMatchItemsMetadata one_pieces
                 */

                /**
                 * Constructs a new MixAndMatchItemsMetadata.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a MixAndMatchItemsMetadata.
                 * @implements IMixAndMatchItemsMetadata
                 * @constructor
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsMetadata=} [properties] Properties to set
                 */
                function MixAndMatchItemsMetadata(properties) {
                    this.color_group_swatch_sets = {};
                    this.tops_default_tuck_state = {};
                    this.bottoms_tuckable = {};
                    this.bodysuits = {};
                    this.one_pieces = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MixAndMatchItemsMetadata color_group_swatch_sets.
                 * @member {Object.<string,snapchat.bitmoji.api.IColorGroupTones>} color_group_swatch_sets
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @instance
                 */
                MixAndMatchItemsMetadata.prototype.color_group_swatch_sets = $util.emptyObject;

                /**
                 * MixAndMatchItemsMetadata tops_default_tuck_state.
                 * @member {Object.<string,snapchat.bitmoji.api.ITopsDefaultTuckState>} tops_default_tuck_state
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @instance
                 */
                MixAndMatchItemsMetadata.prototype.tops_default_tuck_state = $util.emptyObject;

                /**
                 * MixAndMatchItemsMetadata bottoms_tuckable.
                 * @member {Object.<string,boolean>} bottoms_tuckable
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @instance
                 */
                MixAndMatchItemsMetadata.prototype.bottoms_tuckable = $util.emptyObject;

                /**
                 * MixAndMatchItemsMetadata bodysuits.
                 * @member {Object.<string,boolean>} bodysuits
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @instance
                 */
                MixAndMatchItemsMetadata.prototype.bodysuits = $util.emptyObject;

                /**
                 * MixAndMatchItemsMetadata one_pieces.
                 * @member {Object.<string,boolean>} one_pieces
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @instance
                 */
                MixAndMatchItemsMetadata.prototype.one_pieces = $util.emptyObject;

                /**
                 * Creates a new MixAndMatchItemsMetadata instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @static
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsMetadata=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsMetadata} MixAndMatchItemsMetadata instance
                 */
                MixAndMatchItemsMetadata.create = function create(properties) {
                    return new MixAndMatchItemsMetadata(properties);
                };

                /**
                 * Decodes a MixAndMatchItemsMetadata message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsMetadata
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsMetadata} MixAndMatchItemsMetadata
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MixAndMatchItemsMetadata.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.MixAndMatchItemsMetadata(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (message.color_group_swatch_sets === $util.emptyObject)
                                message.color_group_swatch_sets = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.snapchat.bitmoji.api.ColorGroupTones.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.color_group_swatch_sets[key] = value;
                            break;
                        case 2:
                            if (message.tops_default_tuck_state === $util.emptyObject)
                                message.tops_default_tuck_state = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.snapchat.bitmoji.api.TopsDefaultTuckState.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.tops_default_tuck_state[key] = value;
                            break;
                        case 3:
                            if (message.bottoms_tuckable === $util.emptyObject)
                                message.bottoms_tuckable = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = false;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.bottoms_tuckable[key] = value;
                            break;
                        case 4:
                            if (message.bodysuits === $util.emptyObject)
                                message.bodysuits = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = false;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.bodysuits[key] = value;
                            break;
                        case 5:
                            if (message.one_pieces === $util.emptyObject)
                                message.one_pieces = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = false;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.one_pieces[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return MixAndMatchItemsMetadata;
            })();

            api.DefaultColorInfo = (function() {

                /**
                 * Properties of a DefaultColorInfo.
                 * @memberof snapchat.bitmoji.api
                 * @interface IDefaultColorInfo
                 * @property {number|null} [group_id] DefaultColorInfo group_id
                 * @property {number|null} [swatch_set_index] DefaultColorInfo swatch_set_index
                 */

                /**
                 * Constructs a new DefaultColorInfo.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a DefaultColorInfo.
                 * @implements IDefaultColorInfo
                 * @constructor
                 * @param {snapchat.bitmoji.api.IDefaultColorInfo=} [properties] Properties to set
                 */
                function DefaultColorInfo(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DefaultColorInfo group_id.
                 * @member {number} group_id
                 * @memberof snapchat.bitmoji.api.DefaultColorInfo
                 * @instance
                 */
                DefaultColorInfo.prototype.group_id = 0;

                /**
                 * DefaultColorInfo swatch_set_index.
                 * @member {number} swatch_set_index
                 * @memberof snapchat.bitmoji.api.DefaultColorInfo
                 * @instance
                 */
                DefaultColorInfo.prototype.swatch_set_index = 0;

                /**
                 * Creates a new DefaultColorInfo instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.DefaultColorInfo
                 * @static
                 * @param {snapchat.bitmoji.api.IDefaultColorInfo=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.DefaultColorInfo} DefaultColorInfo instance
                 */
                DefaultColorInfo.create = function create(properties) {
                    return new DefaultColorInfo(properties);
                };

                /**
                 * Decodes a DefaultColorInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.DefaultColorInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.DefaultColorInfo} DefaultColorInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DefaultColorInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.DefaultColorInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.group_id = reader.int32();
                            break;
                        case 2:
                            message.swatch_set_index = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return DefaultColorInfo;
            })();

            api.Garment = (function() {

                /**
                 * Properties of a Garment.
                 * @memberof snapchat.bitmoji.api
                 * @interface IGarment
                 * @property {number|null} [id] Garment id
                 * @property {Array.<number>|null} [color_group_ids] Garment color_group_ids
                 * @property {snapchat.bitmoji.api.IDefaultColorInfo|null} [default_color_info] Garment default_color_info
                 * @property {string|null} [default_tuck_state] Garment default_tuck_state
                 * @property {boolean|null} [is_bodysuit] Garment is_bodysuit
                 * @property {boolean|null} [is_one_piece] Garment is_one_piece
                 * @property {Array.<number>|null} [secondary_colors] Garment secondary_colors
                 * @property {boolean|null} [bottom_tuckable] Garment bottom_tuckable
                 */

                /**
                 * Constructs a new Garment.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a Garment.
                 * @implements IGarment
                 * @constructor
                 * @param {snapchat.bitmoji.api.IGarment=} [properties] Properties to set
                 */
                function Garment(properties) {
                    this.color_group_ids = [];
                    this.secondary_colors = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Garment id.
                 * @member {number} id
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.id = 0;

                /**
                 * Garment color_group_ids.
                 * @member {Array.<number>} color_group_ids
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.color_group_ids = $util.emptyArray;

                /**
                 * Garment default_color_info.
                 * @member {snapchat.bitmoji.api.IDefaultColorInfo|null|undefined} default_color_info
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.default_color_info = null;

                /**
                 * Garment default_tuck_state.
                 * @member {string} default_tuck_state
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.default_tuck_state = "";

                /**
                 * Garment is_bodysuit.
                 * @member {boolean} is_bodysuit
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.is_bodysuit = false;

                /**
                 * Garment is_one_piece.
                 * @member {boolean} is_one_piece
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.is_one_piece = false;

                /**
                 * Garment secondary_colors.
                 * @member {Array.<number>} secondary_colors
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.secondary_colors = $util.emptyArray;

                /**
                 * Garment bottom_tuckable.
                 * @member {boolean} bottom_tuckable
                 * @memberof snapchat.bitmoji.api.Garment
                 * @instance
                 */
                Garment.prototype.bottom_tuckable = false;

                /**
                 * Creates a new Garment instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.Garment
                 * @static
                 * @param {snapchat.bitmoji.api.IGarment=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.Garment} Garment instance
                 */
                Garment.create = function create(properties) {
                    return new Garment(properties);
                };

                /**
                 * Decodes a Garment message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.Garment
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.Garment} Garment
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Garment.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.Garment();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int32();
                            break;
                        case 2:
                            if (!(message.color_group_ids && message.color_group_ids.length))
                                message.color_group_ids = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.color_group_ids.push(reader.int32());
                            } else
                                message.color_group_ids.push(reader.int32());
                            break;
                        case 3:
                            message.default_color_info = $root.snapchat.bitmoji.api.DefaultColorInfo.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.default_tuck_state = reader.string();
                            break;
                        case 5:
                            message.is_bodysuit = reader.bool();
                            break;
                        case 6:
                            message.is_one_piece = reader.bool();
                            break;
                        case 7:
                            if (!(message.secondary_colors && message.secondary_colors.length))
                                message.secondary_colors = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.secondary_colors.push(reader.int32());
                            } else
                                message.secondary_colors.push(reader.int32());
                            break;
                        case 8:
                            message.bottom_tuckable = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return Garment;
            })();

            api.MixAndMatchItemsBrand = (function() {

                /**
                 * Properties of a MixAndMatchItemsBrand.
                 * @memberof snapchat.bitmoji.api
                 * @interface IMixAndMatchItemsBrand
                 * @property {number|null} [id] MixAndMatchItemsBrand id
                 * @property {string|null} [name] MixAndMatchItemsBrand name
                 * @property {string|null} [logo] MixAndMatchItemsBrand logo
                 * @property {string|null} [header_background] MixAndMatchItemsBrand header_background
                 * @property {string|null} [store_background] MixAndMatchItemsBrand store_background
                 * @property {Array.<snapchat.bitmoji.api.IGarment>|null} [garments] MixAndMatchItemsBrand garments
                 */

                /**
                 * Constructs a new MixAndMatchItemsBrand.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a MixAndMatchItemsBrand.
                 * @implements IMixAndMatchItemsBrand
                 * @constructor
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsBrand=} [properties] Properties to set
                 */
                function MixAndMatchItemsBrand(properties) {
                    this.garments = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MixAndMatchItemsBrand id.
                 * @member {number} id
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @instance
                 */
                MixAndMatchItemsBrand.prototype.id = 0;

                /**
                 * MixAndMatchItemsBrand name.
                 * @member {string} name
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @instance
                 */
                MixAndMatchItemsBrand.prototype.name = "";

                /**
                 * MixAndMatchItemsBrand logo.
                 * @member {string} logo
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @instance
                 */
                MixAndMatchItemsBrand.prototype.logo = "";

                /**
                 * MixAndMatchItemsBrand header_background.
                 * @member {string} header_background
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @instance
                 */
                MixAndMatchItemsBrand.prototype.header_background = "";

                /**
                 * MixAndMatchItemsBrand store_background.
                 * @member {string} store_background
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @instance
                 */
                MixAndMatchItemsBrand.prototype.store_background = "";

                /**
                 * MixAndMatchItemsBrand garments.
                 * @member {Array.<snapchat.bitmoji.api.IGarment>} garments
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @instance
                 */
                MixAndMatchItemsBrand.prototype.garments = $util.emptyArray;

                /**
                 * Creates a new MixAndMatchItemsBrand instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @static
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsBrand=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsBrand} MixAndMatchItemsBrand instance
                 */
                MixAndMatchItemsBrand.create = function create(properties) {
                    return new MixAndMatchItemsBrand(properties);
                };

                /**
                 * Decodes a MixAndMatchItemsBrand message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsBrand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsBrand} MixAndMatchItemsBrand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MixAndMatchItemsBrand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.MixAndMatchItemsBrand();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int32();
                            break;
                        case 2:
                            message.name = reader.string();
                            break;
                        case 3:
                            message.logo = reader.string();
                            break;
                        case 4:
                            message.header_background = reader.string();
                            break;
                        case 5:
                            message.store_background = reader.string();
                            break;
                        case 6:
                            if (!(message.garments && message.garments.length))
                                message.garments = [];
                            message.garments.push($root.snapchat.bitmoji.api.Garment.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return MixAndMatchItemsBrand;
            })();

            api.MixAndMatchItemsCategory = (function() {

                /**
                 * Properties of a MixAndMatchItemsCategory.
                 * @memberof snapchat.bitmoji.api
                 * @interface IMixAndMatchItemsCategory
                 * @property {number|null} [id] MixAndMatchItemsCategory id
                 * @property {string|null} [name] MixAndMatchItemsCategory name
                 * @property {Array.<snapchat.bitmoji.api.IMixAndMatchItemsBrand>|null} [brands] MixAndMatchItemsCategory brands
                 */

                /**
                 * Constructs a new MixAndMatchItemsCategory.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a MixAndMatchItemsCategory.
                 * @implements IMixAndMatchItemsCategory
                 * @constructor
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsCategory=} [properties] Properties to set
                 */
                function MixAndMatchItemsCategory(properties) {
                    this.brands = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MixAndMatchItemsCategory id.
                 * @member {number} id
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsCategory
                 * @instance
                 */
                MixAndMatchItemsCategory.prototype.id = 0;

                /**
                 * MixAndMatchItemsCategory name.
                 * @member {string} name
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsCategory
                 * @instance
                 */
                MixAndMatchItemsCategory.prototype.name = "";

                /**
                 * MixAndMatchItemsCategory brands.
                 * @member {Array.<snapchat.bitmoji.api.IMixAndMatchItemsBrand>} brands
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsCategory
                 * @instance
                 */
                MixAndMatchItemsCategory.prototype.brands = $util.emptyArray;

                /**
                 * Creates a new MixAndMatchItemsCategory instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsCategory
                 * @static
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsCategory=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsCategory} MixAndMatchItemsCategory instance
                 */
                MixAndMatchItemsCategory.create = function create(properties) {
                    return new MixAndMatchItemsCategory(properties);
                };

                /**
                 * Decodes a MixAndMatchItemsCategory message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsCategory
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsCategory} MixAndMatchItemsCategory
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MixAndMatchItemsCategory.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.MixAndMatchItemsCategory();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int32();
                            break;
                        case 2:
                            message.name = reader.string();
                            break;
                        case 3:
                            if (!(message.brands && message.brands.length))
                                message.brands = [];
                            message.brands.push($root.snapchat.bitmoji.api.MixAndMatchItemsBrand.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return MixAndMatchItemsCategory;
            })();

            api.MixAndMatchItemsGender = (function() {

                /**
                 * Properties of a MixAndMatchItemsGender.
                 * @memberof snapchat.bitmoji.api
                 * @interface IMixAndMatchItemsGender
                 * @property {Array.<snapchat.bitmoji.api.IMixAndMatchItemsCategory>|null} [categories] MixAndMatchItemsGender categories
                 */

                /**
                 * Constructs a new MixAndMatchItemsGender.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a MixAndMatchItemsGender.
                 * @implements IMixAndMatchItemsGender
                 * @constructor
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsGender=} [properties] Properties to set
                 */
                function MixAndMatchItemsGender(properties) {
                    this.categories = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MixAndMatchItemsGender categories.
                 * @member {Array.<snapchat.bitmoji.api.IMixAndMatchItemsCategory>} categories
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsGender
                 * @instance
                 */
                MixAndMatchItemsGender.prototype.categories = $util.emptyArray;

                /**
                 * Creates a new MixAndMatchItemsGender instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsGender
                 * @static
                 * @param {snapchat.bitmoji.api.IMixAndMatchItemsGender=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsGender} MixAndMatchItemsGender instance
                 */
                MixAndMatchItemsGender.create = function create(properties) {
                    return new MixAndMatchItemsGender(properties);
                };

                /**
                 * Decodes a MixAndMatchItemsGender message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.MixAndMatchItemsGender
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.MixAndMatchItemsGender} MixAndMatchItemsGender
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MixAndMatchItemsGender.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.MixAndMatchItemsGender();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.categories && message.categories.length))
                                message.categories = [];
                            message.categories.push($root.snapchat.bitmoji.api.MixAndMatchItemsCategory.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return MixAndMatchItemsGender;
            })();

            api.MixAndMatchItems = (function() {

                /**
                 * Properties of a MixAndMatchItems.
                 * @memberof snapchat.bitmoji.api
                 * @interface IMixAndMatchItems
                 * @property {snapchat.bitmoji.api.IMixAndMatchItemsMetadata|null} [metadata] MixAndMatchItems metadata
                 * @property {snapchat.bitmoji.api.IMixAndMatchItemsGender|null} [female] MixAndMatchItems female
                 * @property {snapchat.bitmoji.api.IMixAndMatchItemsGender|null} [male] MixAndMatchItems male
                 */

                /**
                 * Constructs a new MixAndMatchItems.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a MixAndMatchItems.
                 * @implements IMixAndMatchItems
                 * @constructor
                 * @param {snapchat.bitmoji.api.IMixAndMatchItems=} [properties] Properties to set
                 */
                function MixAndMatchItems(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MixAndMatchItems metadata.
                 * @member {snapchat.bitmoji.api.IMixAndMatchItemsMetadata|null|undefined} metadata
                 * @memberof snapchat.bitmoji.api.MixAndMatchItems
                 * @instance
                 */
                MixAndMatchItems.prototype.metadata = null;

                /**
                 * MixAndMatchItems female.
                 * @member {snapchat.bitmoji.api.IMixAndMatchItemsGender|null|undefined} female
                 * @memberof snapchat.bitmoji.api.MixAndMatchItems
                 * @instance
                 */
                MixAndMatchItems.prototype.female = null;

                /**
                 * MixAndMatchItems male.
                 * @member {snapchat.bitmoji.api.IMixAndMatchItemsGender|null|undefined} male
                 * @memberof snapchat.bitmoji.api.MixAndMatchItems
                 * @instance
                 */
                MixAndMatchItems.prototype.male = null;

                /**
                 * Creates a new MixAndMatchItems instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.MixAndMatchItems
                 * @static
                 * @param {snapchat.bitmoji.api.IMixAndMatchItems=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.MixAndMatchItems} MixAndMatchItems instance
                 */
                MixAndMatchItems.create = function create(properties) {
                    return new MixAndMatchItems(properties);
                };

                /**
                 * Decodes a MixAndMatchItems message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.MixAndMatchItems
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.MixAndMatchItems} MixAndMatchItems
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MixAndMatchItems.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.MixAndMatchItems();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.metadata = $root.snapchat.bitmoji.api.MixAndMatchItemsMetadata.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.female = $root.snapchat.bitmoji.api.MixAndMatchItemsGender.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.male = $root.snapchat.bitmoji.api.MixAndMatchItemsGender.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return MixAndMatchItems;
            })();

            api.FacialFeatureCategory = (function() {

                /**
                 * Properties of a FacialFeatureCategory.
                 * @memberof snapchat.bitmoji.api
                 * @interface IFacialFeatureCategory
                 * @property {string|null} [key] FacialFeatureCategory key
                 * @property {snapchat.bitmoji.api.FacialFeatureCategory.Context|null} [context] FacialFeatureCategory context
                 * @property {Array.<snapchat.bitmoji.api.FacialFeatureCategory.IFacialFeatureOption>|null} [options] FacialFeatureCategory options
                 */

                /**
                 * Constructs a new FacialFeatureCategory.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a FacialFeatureCategory.
                 * @implements IFacialFeatureCategory
                 * @constructor
                 * @param {snapchat.bitmoji.api.IFacialFeatureCategory=} [properties] Properties to set
                 */
                function FacialFeatureCategory(properties) {
                    this.options = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FacialFeatureCategory key.
                 * @member {string} key
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                 * @instance
                 */
                FacialFeatureCategory.prototype.key = "";

                /**
                 * FacialFeatureCategory context.
                 * @member {snapchat.bitmoji.api.FacialFeatureCategory.Context} context
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                 * @instance
                 */
                FacialFeatureCategory.prototype.context = 0;

                /**
                 * FacialFeatureCategory options.
                 * @member {Array.<snapchat.bitmoji.api.FacialFeatureCategory.IFacialFeatureOption>} options
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                 * @instance
                 */
                FacialFeatureCategory.prototype.options = $util.emptyArray;

                /**
                 * Creates a new FacialFeatureCategory instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                 * @static
                 * @param {snapchat.bitmoji.api.IFacialFeatureCategory=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.FacialFeatureCategory} FacialFeatureCategory instance
                 */
                FacialFeatureCategory.create = function create(properties) {
                    return new FacialFeatureCategory(properties);
                };

                /**
                 * Decodes a FacialFeatureCategory message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.FacialFeatureCategory} FacialFeatureCategory
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FacialFeatureCategory.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatureCategory();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.key = reader.string();
                            break;
                        case 2:
                            message.context = reader.int32();
                            break;
                        case 3:
                            if (!(message.options && message.options.length))
                                message.options = [];
                            message.options.push($root.snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Context enum.
                 * @name snapchat.bitmoji.api.FacialFeatureCategory.Context
                 * @enum {number}
                 * @property {number} UNSET=0 UNSET value
                 * @property {number} DUAL=1 DUAL value
                 * @property {number} LEFT=2 LEFT value
                 * @property {number} RIGHT=3 RIGHT value
                 * @property {number} SINGLE=4 SINGLE value
                 */
                FacialFeatureCategory.Context = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSET"] = 0;
                    values[valuesById[1] = "DUAL"] = 1;
                    values[valuesById[2] = "LEFT"] = 2;
                    values[valuesById[3] = "RIGHT"] = 3;
                    values[valuesById[4] = "SINGLE"] = 4;
                    return values;
                })();

                FacialFeatureCategory.FacialFeatureOption = (function() {

                    /**
                     * Properties of a FacialFeatureOption.
                     * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                     * @interface IFacialFeatureOption
                     * @property {string|null} [group_id] FacialFeatureOption group_id
                     */

                    /**
                     * Constructs a new FacialFeatureOption.
                     * @memberof snapchat.bitmoji.api.FacialFeatureCategory
                     * @classdesc Represents a FacialFeatureOption.
                     * @implements IFacialFeatureOption
                     * @constructor
                     * @param {snapchat.bitmoji.api.FacialFeatureCategory.IFacialFeatureOption=} [properties] Properties to set
                     */
                    function FacialFeatureOption(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * FacialFeatureOption group_id.
                     * @member {string} group_id
                     * @memberof snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption
                     * @instance
                     */
                    FacialFeatureOption.prototype.group_id = "";

                    /**
                     * Creates a new FacialFeatureOption instance using the specified properties.
                     * @function create
                     * @memberof snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption
                     * @static
                     * @param {snapchat.bitmoji.api.FacialFeatureCategory.IFacialFeatureOption=} [properties] Properties to set
                     * @returns {snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption} FacialFeatureOption instance
                     */
                    FacialFeatureOption.create = function create(properties) {
                        return new FacialFeatureOption(properties);
                    };

                    /**
                     * Decodes a FacialFeatureOption message from the specified reader or buffer.
                     * @function decode
                     * @memberof snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption} FacialFeatureOption
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FacialFeatureOption.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatureCategory.FacialFeatureOption();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.group_id = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    return FacialFeatureOption;
                })();

                return FacialFeatureCategory;
            })();

            api.FacialFeatureCategories = (function() {

                /**
                 * Properties of a FacialFeatureCategories.
                 * @memberof snapchat.bitmoji.api
                 * @interface IFacialFeatureCategories
                 * @property {Array.<snapchat.bitmoji.api.IFacialFeatureCategory>|null} [categories] FacialFeatureCategories categories
                 */

                /**
                 * Constructs a new FacialFeatureCategories.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a FacialFeatureCategories.
                 * @implements IFacialFeatureCategories
                 * @constructor
                 * @param {snapchat.bitmoji.api.IFacialFeatureCategories=} [properties] Properties to set
                 */
                function FacialFeatureCategories(properties) {
                    this.categories = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FacialFeatureCategories categories.
                 * @member {Array.<snapchat.bitmoji.api.IFacialFeatureCategory>} categories
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategories
                 * @instance
                 */
                FacialFeatureCategories.prototype.categories = $util.emptyArray;

                /**
                 * Creates a new FacialFeatureCategories instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategories
                 * @static
                 * @param {snapchat.bitmoji.api.IFacialFeatureCategories=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.FacialFeatureCategories} FacialFeatureCategories instance
                 */
                FacialFeatureCategories.create = function create(properties) {
                    return new FacialFeatureCategories(properties);
                };

                /**
                 * Decodes a FacialFeatureCategories message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.FacialFeatureCategories
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.FacialFeatureCategories} FacialFeatureCategories
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FacialFeatureCategories.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatureCategories();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.categories && message.categories.length))
                                message.categories = [];
                            message.categories.push($root.snapchat.bitmoji.api.FacialFeatureCategory.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return FacialFeatureCategories;
            })();

            api.StyledFacialFeatureCategories = (function() {

                /**
                 * Properties of a StyledFacialFeatureCategories.
                 * @memberof snapchat.bitmoji.api
                 * @interface IStyledFacialFeatureCategories
                 * @property {snapchat.bitmoji.api.IFacialFeatureCategories|null} [bitstrips] StyledFacialFeatureCategories bitstrips
                 * @property {snapchat.bitmoji.api.IFacialFeatureCategories|null} [bitmoji] StyledFacialFeatureCategories bitmoji
                 * @property {snapchat.bitmoji.api.IFacialFeatureCategories|null} [cm] StyledFacialFeatureCategories cm
                 */

                /**
                 * Constructs a new StyledFacialFeatureCategories.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a StyledFacialFeatureCategories.
                 * @implements IStyledFacialFeatureCategories
                 * @constructor
                 * @param {snapchat.bitmoji.api.IStyledFacialFeatureCategories=} [properties] Properties to set
                 */
                function StyledFacialFeatureCategories(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StyledFacialFeatureCategories bitstrips.
                 * @member {snapchat.bitmoji.api.IFacialFeatureCategories|null|undefined} bitstrips
                 * @memberof snapchat.bitmoji.api.StyledFacialFeatureCategories
                 * @instance
                 */
                StyledFacialFeatureCategories.prototype.bitstrips = null;

                /**
                 * StyledFacialFeatureCategories bitmoji.
                 * @member {snapchat.bitmoji.api.IFacialFeatureCategories|null|undefined} bitmoji
                 * @memberof snapchat.bitmoji.api.StyledFacialFeatureCategories
                 * @instance
                 */
                StyledFacialFeatureCategories.prototype.bitmoji = null;

                /**
                 * StyledFacialFeatureCategories cm.
                 * @member {snapchat.bitmoji.api.IFacialFeatureCategories|null|undefined} cm
                 * @memberof snapchat.bitmoji.api.StyledFacialFeatureCategories
                 * @instance
                 */
                StyledFacialFeatureCategories.prototype.cm = null;

                /**
                 * Creates a new StyledFacialFeatureCategories instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.StyledFacialFeatureCategories
                 * @static
                 * @param {snapchat.bitmoji.api.IStyledFacialFeatureCategories=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.StyledFacialFeatureCategories} StyledFacialFeatureCategories instance
                 */
                StyledFacialFeatureCategories.create = function create(properties) {
                    return new StyledFacialFeatureCategories(properties);
                };

                /**
                 * Decodes a StyledFacialFeatureCategories message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.StyledFacialFeatureCategories
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.StyledFacialFeatureCategories} StyledFacialFeatureCategories
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StyledFacialFeatureCategories.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.StyledFacialFeatureCategories();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.bitstrips = $root.snapchat.bitmoji.api.FacialFeatureCategories.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.bitmoji = $root.snapchat.bitmoji.api.FacialFeatureCategories.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.cm = $root.snapchat.bitmoji.api.FacialFeatureCategories.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return StyledFacialFeatureCategories;
            })();

            api.ColourList = (function() {

                /**
                 * Properties of a ColourList.
                 * @memberof snapchat.bitmoji.api
                 * @interface IColourList
                 * @property {Array.<number>|null} [value] ColourList value
                 */

                /**
                 * Constructs a new ColourList.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a ColourList.
                 * @implements IColourList
                 * @constructor
                 * @param {snapchat.bitmoji.api.IColourList=} [properties] Properties to set
                 */
                function ColourList(properties) {
                    this.value = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColourList value.
                 * @member {Array.<number>} value
                 * @memberof snapchat.bitmoji.api.ColourList
                 * @instance
                 */
                ColourList.prototype.value = $util.emptyArray;

                /**
                 * Creates a new ColourList instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.ColourList
                 * @static
                 * @param {snapchat.bitmoji.api.IColourList=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.ColourList} ColourList instance
                 */
                ColourList.create = function create(properties) {
                    return new ColourList(properties);
                };

                /**
                 * Decodes a ColourList message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.ColourList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.ColourList} ColourList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColourList.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.ColourList();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.value && message.value.length))
                                message.value = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.value.push(reader.int32());
                            } else
                                message.value.push(reader.int32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return ColourList;
            })();

            api.FacialFeatureColourOption = (function() {

                /**
                 * Properties of a FacialFeatureColourOption.
                 * @memberof snapchat.bitmoji.api
                 * @interface IFacialFeatureColourOption
                 * @property {string|null} [id] FacialFeatureColourOption id
                 * @property {Object.<string,snapchat.bitmoji.api.IColourList>|null} [colours] FacialFeatureColourOption colours
                 * @property {snapchat.bitmoji.api.IColourList|null} [icon_colours] FacialFeatureColourOption icon_colours
                 */

                /**
                 * Constructs a new FacialFeatureColourOption.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a FacialFeatureColourOption.
                 * @implements IFacialFeatureColourOption
                 * @constructor
                 * @param {snapchat.bitmoji.api.IFacialFeatureColourOption=} [properties] Properties to set
                 */
                function FacialFeatureColourOption(properties) {
                    this.colours = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FacialFeatureColourOption id.
                 * @member {string} id
                 * @memberof snapchat.bitmoji.api.FacialFeatureColourOption
                 * @instance
                 */
                FacialFeatureColourOption.prototype.id = "";

                /**
                 * FacialFeatureColourOption colours.
                 * @member {Object.<string,snapchat.bitmoji.api.IColourList>} colours
                 * @memberof snapchat.bitmoji.api.FacialFeatureColourOption
                 * @instance
                 */
                FacialFeatureColourOption.prototype.colours = $util.emptyObject;

                /**
                 * FacialFeatureColourOption icon_colours.
                 * @member {snapchat.bitmoji.api.IColourList|null|undefined} icon_colours
                 * @memberof snapchat.bitmoji.api.FacialFeatureColourOption
                 * @instance
                 */
                FacialFeatureColourOption.prototype.icon_colours = null;

                /**
                 * Creates a new FacialFeatureColourOption instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.FacialFeatureColourOption
                 * @static
                 * @param {snapchat.bitmoji.api.IFacialFeatureColourOption=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.FacialFeatureColourOption} FacialFeatureColourOption instance
                 */
                FacialFeatureColourOption.create = function create(properties) {
                    return new FacialFeatureColourOption(properties);
                };

                /**
                 * Decodes a FacialFeatureColourOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.FacialFeatureColourOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.FacialFeatureColourOption} FacialFeatureColourOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FacialFeatureColourOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatureColourOption(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.string();
                            break;
                        case 2:
                            if (message.colours === $util.emptyObject)
                                message.colours = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.snapchat.bitmoji.api.ColourList.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.colours[key] = value;
                            break;
                        case 3:
                            message.icon_colours = $root.snapchat.bitmoji.api.ColourList.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return FacialFeatureColourOption;
            })();

            api.FacialFeatureGroup = (function() {

                /**
                 * Properties of a FacialFeatureGroup.
                 * @memberof snapchat.bitmoji.api
                 * @interface IFacialFeatureGroup
                 * @property {Object.<string,number>|null} [slots] FacialFeatureGroup slots
                 * @property {string|null} [default_colour_id] FacialFeatureGroup default_colour_id
                 * @property {Array.<snapchat.bitmoji.api.IFacialFeatureColourOption>|null} [colour_options] FacialFeatureGroup colour_options
                 */

                /**
                 * Constructs a new FacialFeatureGroup.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a FacialFeatureGroup.
                 * @implements IFacialFeatureGroup
                 * @constructor
                 * @param {snapchat.bitmoji.api.IFacialFeatureGroup=} [properties] Properties to set
                 */
                function FacialFeatureGroup(properties) {
                    this.slots = {};
                    this.colour_options = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FacialFeatureGroup slots.
                 * @member {Object.<string,number>} slots
                 * @memberof snapchat.bitmoji.api.FacialFeatureGroup
                 * @instance
                 */
                FacialFeatureGroup.prototype.slots = $util.emptyObject;

                /**
                 * FacialFeatureGroup default_colour_id.
                 * @member {string} default_colour_id
                 * @memberof snapchat.bitmoji.api.FacialFeatureGroup
                 * @instance
                 */
                FacialFeatureGroup.prototype.default_colour_id = "";

                /**
                 * FacialFeatureGroup colour_options.
                 * @member {Array.<snapchat.bitmoji.api.IFacialFeatureColourOption>} colour_options
                 * @memberof snapchat.bitmoji.api.FacialFeatureGroup
                 * @instance
                 */
                FacialFeatureGroup.prototype.colour_options = $util.emptyArray;

                /**
                 * Creates a new FacialFeatureGroup instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.FacialFeatureGroup
                 * @static
                 * @param {snapchat.bitmoji.api.IFacialFeatureGroup=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.FacialFeatureGroup} FacialFeatureGroup instance
                 */
                FacialFeatureGroup.create = function create(properties) {
                    return new FacialFeatureGroup(properties);
                };

                /**
                 * Decodes a FacialFeatureGroup message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.FacialFeatureGroup
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.FacialFeatureGroup} FacialFeatureGroup
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FacialFeatureGroup.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatureGroup(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (message.slots === $util.emptyObject)
                                message.slots = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = 0;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.slots[key] = value;
                            break;
                        case 2:
                            message.default_colour_id = reader.string();
                            break;
                        case 3:
                            if (!(message.colour_options && message.colour_options.length))
                                message.colour_options = [];
                            message.colour_options.push($root.snapchat.bitmoji.api.FacialFeatureColourOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return FacialFeatureGroup;
            })();

            api.FacialFeatureMetadata = (function() {

                /**
                 * Properties of a FacialFeatureMetadata.
                 * @memberof snapchat.bitmoji.api
                 * @interface IFacialFeatureMetadata
                 * @property {Object.<string,snapchat.bitmoji.api.IFacialFeatureGroup>|null} [groups] FacialFeatureMetadata groups
                 */

                /**
                 * Constructs a new FacialFeatureMetadata.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a FacialFeatureMetadata.
                 * @implements IFacialFeatureMetadata
                 * @constructor
                 * @param {snapchat.bitmoji.api.IFacialFeatureMetadata=} [properties] Properties to set
                 */
                function FacialFeatureMetadata(properties) {
                    this.groups = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FacialFeatureMetadata groups.
                 * @member {Object.<string,snapchat.bitmoji.api.IFacialFeatureGroup>} groups
                 * @memberof snapchat.bitmoji.api.FacialFeatureMetadata
                 * @instance
                 */
                FacialFeatureMetadata.prototype.groups = $util.emptyObject;

                /**
                 * Creates a new FacialFeatureMetadata instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.FacialFeatureMetadata
                 * @static
                 * @param {snapchat.bitmoji.api.IFacialFeatureMetadata=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.FacialFeatureMetadata} FacialFeatureMetadata instance
                 */
                FacialFeatureMetadata.create = function create(properties) {
                    return new FacialFeatureMetadata(properties);
                };

                /**
                 * Decodes a FacialFeatureMetadata message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.FacialFeatureMetadata
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.FacialFeatureMetadata} FacialFeatureMetadata
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FacialFeatureMetadata.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatureMetadata(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (message.groups === $util.emptyObject)
                                message.groups = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.snapchat.bitmoji.api.FacialFeatureGroup.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.groups[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return FacialFeatureMetadata;
            })();

            api.FacialFeatures = (function() {

                /**
                 * Properties of a FacialFeatures.
                 * @memberof snapchat.bitmoji.api
                 * @interface IFacialFeatures
                 * @property {snapchat.bitmoji.api.IStyledFacialFeatureCategories|null} [female] FacialFeatures female
                 * @property {snapchat.bitmoji.api.IStyledFacialFeatureCategories|null} [male] FacialFeatures male
                 * @property {snapchat.bitmoji.api.IFacialFeatureMetadata|null} [metadata] FacialFeatures metadata
                 */

                /**
                 * Constructs a new FacialFeatures.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents a FacialFeatures.
                 * @implements IFacialFeatures
                 * @constructor
                 * @param {snapchat.bitmoji.api.IFacialFeatures=} [properties] Properties to set
                 */
                function FacialFeatures(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FacialFeatures female.
                 * @member {snapchat.bitmoji.api.IStyledFacialFeatureCategories|null|undefined} female
                 * @memberof snapchat.bitmoji.api.FacialFeatures
                 * @instance
                 */
                FacialFeatures.prototype.female = null;

                /**
                 * FacialFeatures male.
                 * @member {snapchat.bitmoji.api.IStyledFacialFeatureCategories|null|undefined} male
                 * @memberof snapchat.bitmoji.api.FacialFeatures
                 * @instance
                 */
                FacialFeatures.prototype.male = null;

                /**
                 * FacialFeatures metadata.
                 * @member {snapchat.bitmoji.api.IFacialFeatureMetadata|null|undefined} metadata
                 * @memberof snapchat.bitmoji.api.FacialFeatures
                 * @instance
                 */
                FacialFeatures.prototype.metadata = null;

                /**
                 * Creates a new FacialFeatures instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.FacialFeatures
                 * @static
                 * @param {snapchat.bitmoji.api.IFacialFeatures=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.FacialFeatures} FacialFeatures instance
                 */
                FacialFeatures.create = function create(properties) {
                    return new FacialFeatures(properties);
                };

                /**
                 * Decodes a FacialFeatures message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.FacialFeatures
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.FacialFeatures} FacialFeatures
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FacialFeatures.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.FacialFeatures();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.female = $root.snapchat.bitmoji.api.StyledFacialFeatureCategories.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.male = $root.snapchat.bitmoji.api.StyledFacialFeatureCategories.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.metadata = $root.snapchat.bitmoji.api.FacialFeatureMetadata.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return FacialFeatures;
            })();

            api.AssetsV3 = (function() {

                /**
                 * Properties of an AssetsV3.
                 * @memberof snapchat.bitmoji.api
                 * @interface IAssetsV3
                 * @property {snapchat.bitmoji.api.ITraits|null} [traits] AssetsV3 traits
                 * @property {snapchat.bitmoji.api.IDefaults|null} [defaults] AssetsV3 defaults
                 * @property {snapchat.bitmoji.api.IOutfits|null} [outfits] AssetsV3 outfits
                 * @property {snapchat.bitmoji.api.IMixAndMatchItems|null} [mix_and_match_items] AssetsV3 mix_and_match_items
                 * @property {snapchat.bitmoji.api.IFacialFeatures|null} [facial_features] AssetsV3 facial_features
                 */

                /**
                 * Constructs a new AssetsV3.
                 * @memberof snapchat.bitmoji.api
                 * @classdesc Represents an AssetsV3.
                 * @implements IAssetsV3
                 * @constructor
                 * @param {snapchat.bitmoji.api.IAssetsV3=} [properties] Properties to set
                 */
                function AssetsV3(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AssetsV3 traits.
                 * @member {snapchat.bitmoji.api.ITraits|null|undefined} traits
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @instance
                 */
                AssetsV3.prototype.traits = null;

                /**
                 * AssetsV3 defaults.
                 * @member {snapchat.bitmoji.api.IDefaults|null|undefined} defaults
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @instance
                 */
                AssetsV3.prototype.defaults = null;

                /**
                 * AssetsV3 outfits.
                 * @member {snapchat.bitmoji.api.IOutfits|null|undefined} outfits
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @instance
                 */
                AssetsV3.prototype.outfits = null;

                /**
                 * AssetsV3 mix_and_match_items.
                 * @member {snapchat.bitmoji.api.IMixAndMatchItems|null|undefined} mix_and_match_items
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @instance
                 */
                AssetsV3.prototype.mix_and_match_items = null;

                /**
                 * AssetsV3 facial_features.
                 * @member {snapchat.bitmoji.api.IFacialFeatures|null|undefined} facial_features
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @instance
                 */
                AssetsV3.prototype.facial_features = null;

                /**
                 * Creates a new AssetsV3 instance using the specified properties.
                 * @function create
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @static
                 * @param {snapchat.bitmoji.api.IAssetsV3=} [properties] Properties to set
                 * @returns {snapchat.bitmoji.api.AssetsV3} AssetsV3 instance
                 */
                AssetsV3.create = function create(properties) {
                    return new AssetsV3(properties);
                };

                /**
                 * Decodes an AssetsV3 message from the specified reader or buffer.
                 * @function decode
                 * @memberof snapchat.bitmoji.api.AssetsV3
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {snapchat.bitmoji.api.AssetsV3} AssetsV3
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AssetsV3.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.snapchat.bitmoji.api.AssetsV3();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.traits = $root.snapchat.bitmoji.api.Traits.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.defaults = $root.snapchat.bitmoji.api.Defaults.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.outfits = $root.snapchat.bitmoji.api.Outfits.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.mix_and_match_items = $root.snapchat.bitmoji.api.MixAndMatchItems.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.facial_features = $root.snapchat.bitmoji.api.FacialFeatures.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                return AssetsV3;
            })();

            return api;
        })();

        return bitmoji;
    })();

    return snapchat;
})();

module.exports = $root;
